import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth, API } from "../App";
import { toast } from "sonner";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Switch } from "../components/ui/switch";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Checkbox } from "../components/ui/checkbox";
import { Progress } from "../components/ui/progress";
import { 
  Plus, Pencil, Trash2, Upload, Send, RefreshCw, Users, Mail, 
  Calendar, CheckCircle, Clock, AlertCircle, FileSpreadsheet,
  Play, Pause, MoreVertical, Download, Eye, Bell, Copy, MessageSquare,
  ChevronLeft, ChevronRight, Settings, BarChart3, FileText, Loader2, Award, ClipboardList,
  LayoutGrid, List, Rows3, Search
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "../components/ui/dropdown-menu";
import { ScrollArea, ScrollBar } from "../components/ui/scroll-area";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, PieChart, Pie, Legend } from 'recharts';

const MESES = [
  { value: "01", label: "Enero" }, { value: "02", label: "Febrero" }, { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" }, { value: "05", label: "Mayo" }, { value: "06", label: "Junio" },
  { value: "07", label: "Julio" }, { value: "08", label: "Agosto" }, { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" }, { value: "11", label: "Noviembre" }, { value: "12", label: "Diciembre" },
];
const _ANIO_ACTUAL = new Date().getFullYear();
const ANIOS = [_ANIO_ACTUAL - 1, _ANIO_ACTUAL, _ANIO_ACTUAL + 1, _ANIO_ACTUAL + 2, _ANIO_ACTUAL + 3];
const nombreMes = (v) => (MESES.find((m) => m.value === v)?.label || v || "");

export default function EncuestasCampanasPage() {
  const { getAuthHeaders, user } = useAuth();
  const soloLectura = user?.solo_lectura_encuestas === true;
  const esAdmin = ["admin", "administrador"].includes(String(user?.role || "").toLowerCase());
  const [campanas, setCampanas] = useState([]);
  const [plantillas, setPlantillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [editingCampana, setEditingCampana] = useState(null);
  const [vistaCampanas, setVistaCampanas] = useState(() => {
    try { return localStorage.getItem("encuestas_vista_campanas") || "detallada"; } catch (_) { return "detallada"; }
  });
  const cambiarVistaCampanas = (v) => {
    setVistaCampanas(v);
    try { localStorage.setItem("encuestas_vista_campanas", v); } catch (_) {}
  };
  const [filtroCampanas, setFiltroCampanas] = useState("");
  const [camposDisponibles, setCamposDisponibles] = useState([]);
  
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    encuesta_id: "",
    campos_requeridos: ["nombre_cliente", "correo", "ejecutivo"],
    // Campos adicionales de configuración
    renovacion_mes: "",
    renovacion_anio: "",
    reclamo_mes: "",
    reclamo_anio: "",
    ejecutivo_encuestar_id: "",
    ejecutivo_encuestar_nombre: "",
    muestras_minimas: "",
    // Configuración de envío
    tipo_envio: "inmediato", // inmediato, programado
    fecha_envio_programado: "",
    hora_envio_programado: "09:00",
    // Configuración de recordatorios
    recordatorios: {
      activo: false,
      dias_primer_recordatorio: 3,
      dias_segundo_recordatorio: 7,
      dias_tercer_recordatorio: 10,
      max_recordatorios: 2,
      hora_envio: "09:00"
    }
  });

  const [recordatoriosDefault, setRecordatoriosDefault] = useState(null);

  // Ejecutivos filtrados por el departamento de la plantilla seleccionada
  const [ejecutivosDept, setEjecutivosDept] = useState([]);
  const [tiposEncuesta, setTiposEncuesta] = useState([]);
  const [loadingEjecutivos, setLoadingEjecutivos] = useState(false);

  const [showDestinatariosDialog, setShowDestinatariosDialog] = useState(false);
  const [selectedCampana, setSelectedCampana] = useState(null);
  const [destinatarios, setDestinatarios] = useState([]);
  const [destinatariosLoading, setDestinatariosLoading] = useState(false);
  const [destinatarioPage, setDestinatarioPage] = useState(1);
  const [destinatarioTotal, setDestinatarioTotal] = useState(0);
  const [searchDest, setSearchDest] = useState("");
  const searchDestTimer = useRef(null);
  const [editingDest, setEditingDest] = useState(null);
  const [editDestForm, setEditDestForm] = useState({ correo: "", padrino: "", email_padrino: "" });
  const [savingDest, setSavingDest] = useState(false);
  const DEST_FORM_VACIO = { nombre_cliente: "", correo: "", telefono: "", contacto: "", poliza: "", aseguradora: "", padrino: "", email_padrino: "", numero_reclamo: "", ejecutivo: "", clase_cliente: "" };
  const [showAddDest, setShowAddDest] = useState(false);
  const [addDestForm, setAddDestForm] = useState(DEST_FORM_VACIO);
  const [savingAddDest, setSavingAddDest] = useState(false);
  const [sendingOneId, setSendingOneId] = useState(null);
  // Cargar Historial
  const [histPlantillaId, setHistPlantillaId] = useState("");
  const [histFile, setHistFile] = useState(null);
  const [histAnalisis, setHistAnalisis] = useState(null);
  const [histMapeo, setHistMapeo] = useState({});
  const [histNombre, setHistNombre] = useState("");
  const [histEjecutivo, setHistEjecutivo] = useState("");
  const [histEjecutivoManual, setHistEjecutivoManual] = useState("");
  const [histUsuarios, setHistUsuarios] = useState([]);
  const [histLoading, setHistLoading] = useState(false);
  const [histResultado, setHistResultado] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [sendingEmails, setSendingEmails] = useState(false);
  const [filterEstado, setFilterEstado] = useState("todos");
  
  // Nuevos estados para pestañas y selección múltiple
  const [activeTab, setActiveTab] = useState("activas");
  const [selectedCampanas, setSelectedCampanas] = useState([]);
  const [showConfirmCerrar, setShowConfirmCerrar] = useState(false);
  const [showConfirmEliminar, setShowConfirmEliminar] = useState(false);
  const [processingBulk, setProcessingBulk] = useState(false);

  // Estados para ver campaña y respuestas
  const [showViewDialog, setShowViewDialog] = useState(false);
  const [viewingCampana, setViewingCampana] = useState(null);
  const [respuestas, setRespuestas] = useState([]);
  const [respuestasLoading, setRespuestasLoading] = useState(false);
  const [dialogTab, setDialogTab] = useState("destinatarios");
  const [exportingExcel, setExportingExcel] = useState(false);
  
  // Estado para importar Excel en el diálogo de crear
  const [importedDestinatarios, setImportedDestinatarios] = useState([]);
  const [importPreview, setImportPreview] = useState(null);
  
  // Estados para mapeo inteligente con IA
  const [importStep, setImportStep] = useState(1); // 1: Subir, 2: Mapear, 3: Preview
  const [mapeoData, setMapeoData] = useState(null);
  const [mapeoActual, setMapeoActual] = useState({});
  const [rawExcelData, setRawExcelData] = useState([]);
  const [mappedPreview, setMappedPreview] = useState(null);
  const [processingIA, setProcessingIA] = useState(false);

  // Estados para análisis de encuesta
  const [showAnalisisDialog, setShowAnalisisDialog] = useState(false);
  const [analisisData, setAnalisisData] = useState(null);
  const [analisisLoading, setAnalisisLoading] = useState(false);
  const [exportingAnalisis, setExportingAnalisis] = useState(false);

  // Programar envío desde el diálogo de Destinatarios
  const [showProgramarDialog, setShowProgramarDialog] = useState(false);
  const [progFecha, setProgFecha] = useState("");
  const [progHora, setProgHora] = useState("09:00");
  const [programando, setProgramando] = useState(false);

  // Borrar estadísticas (con confirmación)
  const [showConfirmBorrarStats, setShowConfirmBorrarStats] = useState(false);
  const [campanaBorrarStats, setCampanaBorrarStats] = useState(null);
  const [borrandoStats, setBorrandoStats] = useState(false);

  // Configuración de envío de reportes estadísticos (NPS bajo)
  const [reportesConfig, setReportesConfig] = useState({ activo: false, umbral_nps: 6, meta_nps: 60, modo_pregunta: "primera_nps", correos_adicionales: "" });
  const [reportesHistorial, setReportesHistorial] = useState([]);
  const [savingReportes, setSavingReportes] = useState(false);
  const [pruebaEmail, setPruebaEmail] = useState("");
  const [pruebaPlantillaId, setPruebaPlantillaId] = useState("");
  const [enviandoPrueba, setEnviandoPrueba] = useState(false);

  // Programaciones de reportes mensuales NPS
  const [datosPrueba, setDatosPrueba] = useState(null);
  const [borrandoPrueba, setBorrandoPrueba] = useState(false);
  const [programaciones, setProgramaciones] = useState([]);
  const [showProgDialog, setShowProgDialog] = useState(false);
  const [editingProg, setEditingProg] = useState(null);
  const [progForm, setProgForm] = useState({ plantilla_id: "", destinatarios: "", correos_cc: "", modo: "automatico", dia_envio: 1, hora_envio: "08:00", corte: "mes_anterior", activo: true });
  const [savingProg, setSavingProg] = useState(false);
  const [showPruebaMensualDialog, setShowPruebaMensualDialog] = useState(false);
  const [pruebaMensualProg, setPruebaMensualProg] = useState(null);
  const [pruebaMensualEmail, setPruebaMensualEmail] = useState("");
  const [enviandoPruebaMensual, setEnviandoPruebaMensual] = useState(false);
  const [enviandoAhoraId, setEnviandoAhoraId] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [campanasRes, plantillasRes] = await Promise.all([
        axios.get(`${API}/encuestas/campanas`, getAuthHeaders()),
        axios.get(`${API}/encuestas/plantillas`, getAuthHeaders())
      ]);
      setCampanas(campanasRes.data);
      setPlantillas(plantillasRes.data.filter(p => p.activa));
      
      // Cargar campos y configuración de recordatorios
      fetchCamposDisponibles();
      fetchRecordatoriosDefault();
      fetchTiposEncuesta();
    } catch (err) {
      toast.error("Error al cargar datos");
    } finally {
      setLoading(false);
    }
  };

  const fetchTiposEncuesta = async () => {
    try {
      const res = await axios.get(`${API}/encuestas/tipos-encuesta`, getAuthHeaders());
      setTiposEncuesta(res.data || []);
    } catch (err) {
      console.error("Error loading tipos-encuesta:", err);
    }
  };

  // Devuelve el campo de fecha ("renovacion" | "reclamo" | "ninguno") de la plantilla seleccionada
  const getCampoFechaPlantilla = (plantillaId) => {
    const plantilla = plantillas.find((p) => p.id === plantillaId);
    if (!plantilla) return "ninguno";
    const tipo = tiposEncuesta.find((t) => t.id === plantilla.tipo);
    return tipo?.campo_fecha || "ninguno";
  };

  const fetchCamposDisponibles = async () => {
    try {
      const res = await axios.get(`${API}/encuestas/campos`, getAuthHeaders());
      setCamposDisponibles(res.data.filter(c => c.activo));
    } catch (err) {
      console.error("Error loading campos:", err);
    }
  };

  const fetchRecordatoriosDefault = async () => {
    try {
      const res = await axios.get(`${API}/encuestas/config/recordatorios`, getAuthHeaders());
      setRecordatoriosDefault(res.data);
    } catch (err) {
      console.error("Error loading recordatorios config:", err);
    }
  };

  const fetchEjecutivosByPlantilla = async (plantillaId) => {
    const plantilla = plantillas.find((p) => p.id === plantillaId);
    if (!plantilla || (!plantilla.departamento_id && !plantilla.departamento_nombre)) {
      setEjecutivosDept([]);
      return;
    }
    setLoadingEjecutivos(true);
    try {
      const params = new URLSearchParams();
      if (plantilla.departamento_id) params.append("departamento_id", plantilla.departamento_id);
      if (plantilla.departamento_nombre) params.append("departamento_nombre", plantilla.departamento_nombre);
      const res = await axios.get(`${API}/encuestas/usuarios-por-departamento?${params.toString()}`, getAuthHeaders());
      setEjecutivosDept(res.data || []);
    } catch (err) {
      console.error("Error loading ejecutivos:", err);
      setEjecutivosDept([]);
    } finally {
      setLoadingEjecutivos(false);
    }
  };

  const handlePlantillaChange = (plantillaId) => {
    // Al cambiar la plantilla se resetea el ejecutivo y se recargan los del nuevo departamento
    setFormData((prev) => ({ ...prev, encuesta_id: plantillaId, ejecutivo_encuestar_id: "", ejecutivo_encuestar_nombre: "" }));
    fetchEjecutivosByPlantilla(plantillaId);
  };

  const fetchDestinatarios = useCallback(async (campanaId, estado = "todos", page = 1, buscar = "") => {
    setDestinatariosLoading(true);
    try {
      let url = `${API}/encuestas/campanas/${campanaId}/destinatarios?page=${page}&limit=50`;
      if (estado !== "todos") {
        url += `&estado=${estado}`;
      }
      if (buscar && buscar.trim()) {
        url += `&buscar=${encodeURIComponent(buscar.trim())}`;
      }
      const res = await axios.get(url, getAuthHeaders());
      setDestinatarios(res.data.destinatarios);
      setDestinatarioTotal(res.data.total);
      setDestinatarioPage(res.data.page);
    } catch (err) {
      toast.error("Error al cargar destinatarios");
    } finally {
      setDestinatariosLoading(false);
    }
  }, [getAuthHeaders]);

  const fetchRespuestas = useCallback(async (campanaId) => {
    setRespuestasLoading(true);
    try {
      const res = await axios.get(`${API}/encuestas/campanas/${campanaId}/respuestas`, getAuthHeaders());
      setRespuestas(res.data);
    } catch (err) {
      toast.error("Error al cargar respuestas");
    } finally {
      setRespuestasLoading(false);
    }
  }, [getAuthHeaders]);

  const handleSubmit = async () => {
    if (!formData.nombre.trim()) {
      toast.error("El nombre es requerido");
      return;
    }
    if (!formData.encuesta_id) {
      toast.error("Seleccione una encuesta");
      return;
    }
    if (!formData.ejecutivo_encuestar_id) {
      toast.error("Seleccione el ejecutivo a encuestar");
      return;
    }
    const muestras = parseInt(formData.muestras_minimas, 10);
    if (!muestras || muestras < 1) {
      toast.error("Indique una cantidad de muestras mínimas válida (mayor a 0)");
      return;
    }

    try {
      let campanaId;
      const esNuevaCampana = !editingCampana;
      const tipoEnvioInmediato = formData.tipo_envio === "inmediato";

      const payload = { ...formData, muestras_minimas: muestras };

      if (editingCampana) {
        await axios.put(`${API}/encuestas/campanas/${editingCampana.id}`, payload, getAuthHeaders());
        campanaId = editingCampana.id;
        toast.success("Campaña actualizada");
      } else {
        const res = await axios.post(`${API}/encuestas/campanas`, payload, getAuthHeaders());
        campanaId = res.data.id;
        toast.success("Campaña creada");
      }
      
      // Si hay destinatarios importados, subirlos
      let destinatariosGuardados = false;
      if (importedDestinatarios.length > 0 && campanaId) {
        try {
          const bulkRes = await axios.post(
            `${API}/encuestas/campanas/${campanaId}/destinatarios/bulk`,
            { destinatarios: importedDestinatarios },
            getAuthHeaders()
          );
          toast.success(`${importedDestinatarios.length} destinatarios importados`);
          destinatariosGuardados = true;
          console.log("Destinatarios guardados:", bulkRes.data);
        } catch (importErr) {
          console.error("Error al importar destinatarios:", importErr);
          toast.error("Error al importar destinatarios");
        }
      }
      
      // Si el tipo de envío es "inmediato", es nueva campaña y hay destinatarios, enviar automáticamente
      if (tipoEnvioInmediato && esNuevaCampana && destinatariosGuardados) {
        try {
          console.log("Enviando encuestas automáticamente para campaña:", campanaId);
          const envioRes = await axios.post(
            `${API}/encuestas/campanas/${campanaId}/enviar`,
            {},
            getAuthHeaders()
          );
          console.log("Respuesta de envío:", envioRes.data);
          toast.success(`Encuestas enviadas: ${envioRes.data.enviados} de ${envioRes.data.total}`);
        } catch (envioErr) {
          console.error("Error al enviar encuestas:", envioErr.response?.data || envioErr);
          toast.warning(`Campaña creada pero las encuestas no se enviaron: ${envioErr.response?.data?.detail || 'Error desconocido'}. Puede enviarlas manualmente.`);
        }
      }
      
      setShowDialog(false);
      resetForm();
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al guardar");
    }
  };

  const handleDelete = async (id) => {
    if (!confirm("¿Está seguro de eliminar esta campaña? Se eliminarán todos los destinatarios y respuestas.")) return;
    try {
      await axios.delete(`${API}/encuestas/campanas/${id}`, getAuthHeaders());
      toast.success("Campaña eliminada");
      fetchData();
    } catch (err) {
      toast.error("Error al eliminar");
    }
  };

  const handleClonar = async (campana) => {
    try {
      const res = await axios.post(`${API}/encuestas/campanas/${campana.id}/clonar`, {}, getAuthHeaders());
      toast.success(`Campaña "${res.data.nombre}" creada`);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al clonar campaña");
    }
  };

  const openView = (campana) => {
    setViewingCampana(campana);
    setDialogTab("destinatarios");
    fetchDestinatarios(campana.id);
    fetchRespuestas(campana.id);
    setShowViewDialog(true);
  };

  // ====== FLUJO DE IMPORTACIÓN CON IA ======
  
  const handleImportExcelIA = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setUploadingFile(true);
    setProcessingIA(true);
    const formDataFile = new FormData();
    formDataFile.append("file", file);
    
    try {
      // Paso 1: Usar IA para sugerir mapeo
      const res = await axios.post(`${API}/encuestas/mapeo-ia`, formDataFile, {
        ...getAuthHeaders(),
        headers: {
          ...getAuthHeaders().headers,
          "Content-Type": "multipart/form-data"
        }
      });
      
      setMapeoData(res.data);
      setMapeoActual(res.data.sugerencias || {});
      setRawExcelData(res.data.sample_data || []);
      setImportStep(2); // Ir al paso de mapeo
      
      if (res.data.ia_usada) {
        toast.success(`IA analizó ${res.data.total_filas} registros y sugirió mapeo con ${Math.round((res.data.confianza_ia || 0) * 100)}% confianza`);
      } else {
        toast.info("Mapeo sugerido basado en nombres de columnas");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al procesar archivo");
    } finally {
      setUploadingFile(false);
      setProcessingIA(false);
      e.target.value = "";
    }
  };

  const handleAplicarMapeo = async () => {
    if (!mapeoData) return;
    
    setProcessingIA(true);
    try {
      // Aplicar el mapeo usando los datos completos del Excel guardados en mapeoData.all_data
      const res = await axios.post(`${API}/encuestas/aplicar-mapeo`, {
        mapeo: mapeoActual,
        datos_raw: mapeoData.all_data || mapeoData.sample_data || []
      }, getAuthHeaders());
      
      setMappedPreview(res.data);
      setImportedDestinatarios(res.data.todos_destinatarios || []);
      setImportStep(3); // Ir a preview
      
      toast.success(`${res.data.total_validos} registros mapeados correctamente`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al aplicar mapeo");
    } finally {
      setProcessingIA(false);
    }
  };

  const handleConfirmarImportacion = () => {
    // Los datos ya están en importedDestinatarios
    setImportStep(1);
    toast.success(`${importedDestinatarios.length} destinatarios listos para guardar`);
  };

  const clearImport = () => {
    setImportedDestinatarios([]);
    setImportPreview(null);
    setMapeoData(null);
    setMapeoActual({});
    setRawExcelData([]);
    setMappedPreview(null);
    setImportStep(1);
  };

  const handleExportExcel = async (campanaId) => {
    setExportingExcel(true);
    try {
      const response = await axios.get(
        `${API}/encuestas/campanas/${campanaId}/exportar-excel`,
        {
          ...getAuthHeaders(),
          responseType: 'blob'
        }
      );
      
      // Crear link de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Obtener nombre del archivo del header o usar default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'encuesta_export.xlsx';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=(.+)/);
        if (filenameMatch) {
          filename = filenameMatch[1].replace(/"/g, '');
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("Excel exportado correctamente");
    } catch (err) {
      toast.error("Error al exportar Excel");
    } finally {
      setExportingExcel(false);
    }
  };

  const resetForm = () => {
    setFormData({
      nombre: "",
      descripcion: "",
      encuesta_id: "",
      campos_requeridos: ["nombre_cliente", "correo", "ejecutivo"],
      renovacion_mes: "",
      renovacion_anio: "",
      reclamo_mes: "",
      reclamo_anio: "",
      ejecutivo_encuestar_id: "",
      ejecutivo_encuestar_nombre: "",
      muestras_minimas: "",
      tipo_envio: "inmediato",
      fecha_envio_programado: "",
      hora_envio_programado: "09:00",
      recordatorios: recordatoriosDefault ? {
        activo: recordatoriosDefault.activo,
        dias_primer_recordatorio: recordatoriosDefault.dias_primer_recordatorio,
        dias_segundo_recordatorio: recordatoriosDefault.dias_segundo_recordatorio,
        dias_tercer_recordatorio: recordatoriosDefault.dias_tercer_recordatorio,
        max_recordatorios: recordatoriosDefault.max_recordatorios,
        hora_envio: recordatoriosDefault.hora_envio
      } : {
        activo: false,
        dias_primer_recordatorio: 3,
        dias_segundo_recordatorio: 7,
        dias_tercer_recordatorio: 10,
        max_recordatorios: 2,
        hora_envio: "09:00"
      }
    });
    setEditingCampana(null);
    setImportedDestinatarios([]);
    setImportPreview(null);
    setMapeoData(null);
    setMapeoActual({});
    setRawExcelData([]);
    setMappedPreview(null);
    setImportStep(1);
    setEjecutivosDept([]);
  };

  const openEdit = (campana) => {
    setEditingCampana(campana);
    setFormData({
      nombre: campana.nombre,
      descripcion: campana.descripcion || "",
      encuesta_id: campana.encuesta_id,
      campos_requeridos: campana.campos_requeridos || ["nombre_cliente", "correo", "ejecutivo"],
      renovacion_mes: campana.renovacion_mes || "",
      renovacion_anio: campana.renovacion_anio || "",
      reclamo_mes: campana.reclamo_mes || "",
      reclamo_anio: campana.reclamo_anio || "",
      ejecutivo_encuestar_id: campana.ejecutivo_encuestar_id || "",
      ejecutivo_encuestar_nombre: campana.ejecutivo_encuestar_nombre || "",
      muestras_minimas: campana.muestras_minimas != null ? String(campana.muestras_minimas) : "",
      tipo_envio: campana.tipo_envio || "inmediato",
      fecha_envio_programado: campana.fecha_envio_programado || "",
      hora_envio_programado: campana.hora_envio_programado || "09:00",
      recordatorios: {
        activo: campana.recordatorios?.activo || false,
        dias_primer_recordatorio: campana.recordatorios?.dias_primer_recordatorio || 3,
        dias_segundo_recordatorio: campana.recordatorios?.dias_segundo_recordatorio || 7,
        dias_tercer_recordatorio: campana.recordatorios?.dias_tercer_recordatorio || 10,
        max_recordatorios: campana.recordatorios?.max_recordatorios || 2,
        hora_envio: campana.recordatorios?.hora_envio || "09:00"
      }
    });
    fetchEjecutivosByPlantilla(campana.encuesta_id);
    setShowDialog(true);
  };

  const handleEnviarAUno = async (dest) => {
    if (!window.confirm(`¿Enviar la encuesta a ${dest.nombre_cliente || dest.correo}?`)) return;
    setSendingOneId(dest.id);
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/enviar`,
        { destinatario_ids: [dest.id] },
        getAuthHeaders()
      );
      if (res.data?.enviados > 0) {
        toast.success(`Encuesta enviada a ${dest.correo}`);
      } else {
        toast.error("No se pudo enviar la encuesta. Verifique la configuración SMTP.");
      }
      await fetchDestinatarios(selectedCampana.id, filterEstado, destinatarioPage, searchDest);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar la encuesta");
    } finally {
      setSendingOneId(null);
    }
  };

  const handleAgregarDestinatario = async () => {
    if (!addDestForm.nombre_cliente.trim()) {
      toast.error("El nombre del cliente es requerido");
      return;
    }
    if (!addDestForm.correo.trim() || !addDestForm.correo.includes("@")) {
      toast.error("Ingrese un correo válido");
      return;
    }
    if (addDestForm.email_padrino.trim() && !addDestForm.email_padrino.includes("@")) {
      toast.error("El email del padrino no es válido");
      return;
    }
    setSavingAddDest(true);
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/destinatarios/bulk`,
        { destinatarios: [addDestForm] },
        getAuthHeaders()
      );
      if (res.data?.duplicados > 0) {
        toast.error("Ya existe un destinatario con ese correo en la campaña");
      } else {
        toast.success("Destinatario agregado");
        setShowAddDest(false);
        setAddDestForm(DEST_FORM_VACIO);
        await fetchDestinatarios(selectedCampana.id, filterEstado, destinatarioPage, searchDest);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al agregar el destinatario");
    } finally {
      setSavingAddDest(false);
    }
  };

  const fetchHistUsuarios = async () => {
    try {
      const res = await axios.get(`${API}/users`, getAuthHeaders());
      setHistUsuarios((res.data || []).filter((u) => u.is_active !== false && u.name));
    } catch (err) {
      console.error("Error cargando usuarios:", err);
    }
  };

  const handleDeshacerImportacion = async (campana) => {
    if (!window.confirm(`¿Eliminar por completo la importación "${campana.nombre}" (${campana.total_respondidos || 0} respuestas)? Esta acción no se puede deshacer.`)) return;
    try {
      const res = await axios.delete(`${API}/encuestas/historial/${campana.id}`, getAuthHeaders());
      toast.success(`Importación eliminada: ${res.data?.respuestas ?? 0} respuestas${res.data?.preguntas_historicas_eliminadas ? `, ${res.data.preguntas_historicas_eliminadas} pregunta(s) histórica(s)` : ""}`);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al deshacer la importación");
    }
  };

  const handleAnalizarHistorial = async () => {
    if (!histPlantillaId) { toast.error("Seleccione la plantilla destino"); return; }
    if (!histFile) { toast.error("Seleccione el archivo del historial (.xlsx o .csv)"); return; }
    setHistLoading(true);
    setHistResultado(null);
    try {
      const fd = new FormData();
      fd.append("plantilla_id", histPlantillaId);
      fd.append("file", histFile);
      const res = await axios.post(`${API}/encuestas/historial/analizar`, fd, getAuthHeaders());
      setHistAnalisis(res.data);
      const mapeoInicial = {};
      (res.data.sugerencias || []).forEach((s) => {
        const sug = s.sugerencia || {};
        mapeoInicial[s.columna] = sug.tipo === "pregunta" ? `pregunta::${sug.pregunta_id}` : sug.tipo;
      });
      setHistMapeo(mapeoInicial);
      const pl = plantillas.find((p) => p.id === histPlantillaId);
      setHistNombre(`[HISTÓRICO] ${pl?.nombre || "Encuestas"}`);
      toast.success(`Archivo analizado: ${res.data.total_filas} filas detectadas`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al analizar el archivo");
    } finally {
      setHistLoading(false);
    }
  };

  const handleImportarHistorial = async () => {
    const ejecutivoFinal = histEjecutivo === "__manual__" ? histEjecutivoManual.trim() : histEjecutivo;
    if (!ejecutivoFinal) { toast.error("Indique a qué ejecutivo corresponde el historial"); return; }
    if (!histNombre.trim()) { toast.error("Indique el nombre de la campaña histórica"); return; }
    if (!Object.values(histMapeo).includes("fecha")) {
      toast.error("Debe mapear una columna como 'Fecha de respuesta'");
      return;
    }
    setHistLoading(true);
    try {
      const mapeoFinal = {};
      Object.entries(histMapeo).forEach(([col, val]) => {
        if (val.startsWith("pregunta::")) {
          mapeoFinal[col] = { tipo: "pregunta", pregunta_id: val.split("::")[1] };
        } else {
          mapeoFinal[col] = { tipo: val };
        }
      });
      const fd = new FormData();
      fd.append("plantilla_id", histPlantillaId);
      fd.append("nombre_campana", histNombre.trim());
      fd.append("ejecutivo", ejecutivoFinal);
      fd.append("mapeo", JSON.stringify(mapeoFinal));
      fd.append("file", histFile);
      const res = await axios.post(`${API}/encuestas/historial/importar`, fd, getAuthHeaders());
      setHistResultado(res.data);
      setHistAnalisis(null);
      setHistFile(null);
      toast.success(`Historial importado: ${res.data.importadas} respuestas`);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al importar el historial");
    } finally {
      setHistLoading(false);
    }
  };

  const handleGuardarDestinatario = async () => {
    if (!editingDest || !selectedCampana) return;
    setSavingDest(true);
    try {
      await axios.put(
        `${API}/encuestas/campanas/${selectedCampana.id}/destinatarios/${editingDest.id}`,
        editDestForm,
        getAuthHeaders()
      );
      toast.success("Destinatario actualizado");
      setEditingDest(null);
      await fetchDestinatarios(selectedCampana.id, filterEstado, destinatarioPage, searchDest);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al actualizar el destinatario");
    } finally {
      setSavingDest(false);
    }
  };

  const openDestinatarios = async (campana) => {
    setSelectedCampana(campana);
    setFilterEstado("todos");
    setShowDestinatariosDialog(true);
    await fetchDestinatarios(campana.id);
  };

  // === Importación con mapeo (diálogo Destinatarios) ===
  const [destImportStep, setDestImportStep] = useState(0); // 0 cerrado, 2 mapear, 3 preview
  const [destMapeoData, setDestMapeoData] = useState(null);
  const [destMapeoActual, setDestMapeoActual] = useState({});
  const [destMappedPreview, setDestMappedPreview] = useState(null);
  const [destImporting, setDestImporting] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingFile(true);
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      // Mismo flujo de mapeo inteligente que "Importar Excel" de Editar Campaña
      const res = await axios.post(`${API}/encuestas/mapeo-ia`, formDataUpload, {
        ...getAuthHeaders(),
        headers: { ...getAuthHeaders().headers, "Content-Type": "multipart/form-data" }
      });
      setDestMapeoData(res.data);
      setDestMapeoActual(res.data.sugerencias || {});
      setDestMappedPreview(null);
      setDestImportStep(2);
      if (res.data.ia_usada) {
        toast.success(`IA analizó ${res.data.total_filas} registros y sugirió el mapeo`);
      } else {
        toast.info("Mapeo sugerido basado en nombres de columnas");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al procesar archivo");
    } finally {
      setUploadingFile(false);
      e.target.value = "";
    }
  };

  const handleDestAplicarMapeo = async () => {
    if (!destMapeoData) return;
    setDestImporting(true);
    try {
      const res = await axios.post(`${API}/encuestas/aplicar-mapeo`, {
        mapeo: destMapeoActual,
        datos_raw: destMapeoData.all_data || destMapeoData.sample_data || []
      }, getAuthHeaders());
      setDestMappedPreview(res.data);
      setDestImportStep(3);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al aplicar mapeo");
    } finally {
      setDestImporting(false);
    }
  };

  const handleDestConfirmarImport = async () => {
    if (!destMappedPreview?.todos_destinatarios?.length || !selectedCampana) return;
    setDestImporting(true);
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/destinatarios/bulk`,
        { destinatarios: destMappedPreview.todos_destinatarios },
        getAuthHeaders()
      );
      toast.success(`${res.data.importados} destinatarios importados${res.data.duplicados ? ` (${res.data.duplicados} duplicados omitidos)` : ""}`);
      setDestImportStep(0);
      setDestMapeoData(null);
      setDestMappedPreview(null);
      await fetchDestinatarios(selectedCampana.id, filterEstado);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al importar destinatarios");
    } finally {
      setDestImporting(false);
    }
  };

  const handleEnviarEncuestas = async () => {
    if (!selectedCampana) return;
    
    setSendingEmails(true);
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/enviar`,
        {},
        getAuthHeaders()
      );
      toast.success(`${res.data.enviados} encuestas enviadas`);
      if (res.data.errores > 0) {
        toast.warning(`${res.data.errores} errores al enviar`);
      }
      await fetchDestinatarios(selectedCampana.id, filterEstado);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar encuestas");
    } finally {
      setSendingEmails(false);
    }
  };

  const handleEnviarRecordatorios = async () => {
    if (!selectedCampana) return;
    
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/enviar-recordatorios`,
        {},
        getAuthHeaders()
      );
      toast.success(res.data.message);
      await fetchDestinatarios(selectedCampana.id, filterEstado);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar recordatorios");
    }
  };

  const handleEliminarDestinatario = async (destinatarioId) => {
    try {
      await axios.delete(
        `${API}/encuestas/campanas/${selectedCampana.id}/destinatarios/${destinatarioId}`,
        getAuthHeaders()
      );
      toast.success("Destinatario eliminado");
      await fetchDestinatarios(selectedCampana.id, filterEstado);
      fetchData();
    } catch (err) {
      toast.error("Error al eliminar");
    }
  };

  const handleEliminarTodos = async () => {
    if (!confirm("¿Está seguro de eliminar TODOS los destinatarios de esta campaña?")) return;
    try {
      await axios.delete(
        `${API}/encuestas/campanas/${selectedCampana.id}/destinatarios`,
        getAuthHeaders()
      );
      toast.success("Todos los destinatarios eliminados");
      await fetchDestinatarios(selectedCampana.id);
      fetchData();
    } catch (err) {
      toast.error("Error al eliminar");
    }
  };

  // Funciones para selección múltiple y acciones masivas
  const toggleSelectCampana = (campanaId) => {
    setSelectedCampanas(prev => 
      prev.includes(campanaId) 
        ? prev.filter(id => id !== campanaId)
        : [...prev, campanaId]
    );
  };

  const toggleSelectAll = (campanasList) => {
    if (selectedCampanas.length === campanasList.length) {
      setSelectedCampanas([]);
    } else {
      setSelectedCampanas(campanasList.map(c => c.id));
    }
  };

  const handleCerrarCampana = async (campanaId) => {
    try {
      await axios.post(
        `${API}/encuestas/campanas/${campanaId}/cerrar`,
        {},
        getAuthHeaders()
      );
      toast.success("Encuesta cerrada correctamente");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cerrar encuesta");
    }
  };

  const handlePausarCampana = async (campanaId) => {
    try {
      await axios.post(`${API}/encuestas/campanas/${campanaId}/pausar`, {}, getAuthHeaders());
      toast.success("Encuesta inactivada. Puede realizar modificaciones y luego activarla nuevamente.");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al inactivar encuesta");
    }
  };

  const handleReactivarCampana = async (campanaId) => {
    try {
      await axios.post(`${API}/encuestas/campanas/${campanaId}/reactivar`, {}, getAuthHeaders());
      toast.success("Encuesta activada nuevamente");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al activar encuesta");
    }
  };

  const handleBorrarEstadisticas = async () => {
    if (!campanaBorrarStats) return;
    setBorrandoStats(true);
    try {
      const res = await axios.delete(`${API}/encuestas/campanas/${campanaBorrarStats.id}/respuestas`, getAuthHeaders());
      toast.success(res.data.message || "Estadísticas borradas");
      setShowConfirmBorrarStats(false);
      setCampanaBorrarStats(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al borrar estadísticas");
    } finally {
      setBorrandoStats(false);
    }
  };

  const handleProgramarEnvio = async () => {
    if (!selectedCampana) return;
    if (!progFecha) {
      toast.error("Seleccione la fecha de envío");
      return;
    }
    setProgramando(true);
    try {
      const res = await axios.post(
        `${API}/encuestas/campanas/${selectedCampana.id}/programar`,
        { fecha_envio_programado: progFecha, hora_envio_programado: progHora || "09:00" },
        getAuthHeaders()
      );
      toast.success(res.data.message || "Envío programado");
      setShowProgramarDialog(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al programar envío");
    } finally {
      setProgramando(false);
    }
  };

  const fetchReportesConfig = async () => {
    try {
      const [cfgRes, histRes, progRes, pruebaRes] = await Promise.all([
        axios.get(`${API}/encuestas/reportes-estadisticos/config`, getAuthHeaders()),
        axios.get(`${API}/encuestas/reportes-estadisticos/historial?limite=30`, getAuthHeaders()),
        axios.get(`${API}/encuestas/reportes-estadisticos/programaciones`, getAuthHeaders()),
        axios.get(`${API}/encuestas/datos-prueba/estado`, getAuthHeaders()).catch(() => ({ data: { existe: false } }))
      ]);
      setDatosPrueba(pruebaRes.data || { existe: false });
      setReportesConfig({
        activo: cfgRes.data.activo || false,
        umbral_nps: cfgRes.data.umbral_nps ?? 6,
        meta_nps: cfgRes.data.meta_nps ?? 60,
        modo_pregunta: cfgRes.data.modo_pregunta || "primera_nps",
        correos_adicionales: (cfgRes.data.correos_adicionales || []).join(", ")
      });
      setReportesHistorial(histRes.data || []);
      setProgramaciones(progRes.data || []);
    } catch (err) {
      console.error("Error cargando config de reportes:", err);
    }
  };

  const handleBorrarDatosPrueba = async () => {
    if (!window.confirm("¿Eliminar la plantilla, campaña y todas las respuestas de PRUEBA? Esta acción no se puede deshacer y los datos no se vuelven a crear.")) return;
    setBorrandoPrueba(true);
    try {
      const res = await axios.delete(`${API}/encuestas/datos-prueba`, getAuthHeaders());
      toast.success(res.data?.message || "Datos de prueba eliminados");
      setDatosPrueba({ existe: false });
      fetchData();
      fetchReportesConfig();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error eliminando los datos de prueba");
    } finally {
      setBorrandoPrueba(false);
    }
  };

  const handleBorrarHistorialReportes = async () => {
    if (!window.confirm("¿Borrar TODO el historial de reportes enviados? Esta acción no se puede deshacer.")) return;
    try {
      const res = await axios.delete(`${API}/encuestas/reportes-estadisticos/historial`, getAuthHeaders());
      toast.success(`${res.data?.message || "Historial eliminado"} (${res.data?.eliminados ?? 0} registros)`);
      setReportesHistorial([]);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al borrar el historial");
    }
  };

  const handleGuardarReportesConfig = async () => {
    setSavingReportes(true);
    try {
      await axios.put(`${API}/encuestas/reportes-estadisticos/config`, {
        activo: reportesConfig.activo,
        umbral_nps: parseInt(reportesConfig.umbral_nps, 10) || 6,
        meta_nps: parseFloat(reportesConfig.meta_nps) || 60,
        modo_pregunta: reportesConfig.modo_pregunta || "primera_nps",
        correos_adicionales: (reportesConfig.correos_adicionales || "").split(/[,;\n]+/).map((c) => c.trim()).filter((c) => c.includes("@"))
      }, getAuthHeaders());
      toast.success("Configuración de reportes guardada");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al guardar configuración");
    } finally {
      setSavingReportes(false);
    }
  };

  const handleEnviarPrueba = async () => {
    if (!pruebaEmail || !pruebaEmail.includes("@")) {
      toast.error("Indique un correo válido para la prueba");
      return;
    }
    if (!pruebaPlantillaId) {
      toast.error("Seleccione la encuesta (plantilla) para generar el reporte de prueba");
      return;
    }
    setEnviandoPrueba(true);
    try {
      const res = await axios.post(`${API}/encuestas/reportes-estadisticos/enviar-prueba`, {
        email: pruebaEmail,
        plantilla_id: pruebaPlantillaId
      }, getAuthHeaders());
      toast.success(res.data.message || "Correo de prueba enviado");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar el correo de prueba");
    } finally {
      setEnviandoPrueba(false);
    }
  };

  const openNuevaProg = () => {
    setEditingProg(null);
    setProgForm({ plantilla_id: "", destinatarios: "", correos_cc: "", modo: "automatico", dia_envio: 1, hora_envio: "08:00", corte: "mes_anterior", activo: true });
    setShowProgDialog(true);
  };

  const openEditProg = (prog) => {
    setEditingProg(prog);
    setProgForm({
      plantilla_id: prog.plantilla_id,
      destinatarios: (prog.destinatarios || []).join(", "),
      correos_cc: (prog.correos_cc || []).join(", "),
      modo: prog.modo || "automatico",
      dia_envio: prog.dia_envio ?? 1,
      hora_envio: prog.hora_envio || "08:00",
      corte: prog.corte || "mes_anterior",
      activo: prog.activo !== false
    });
    setShowProgDialog(true);
  };

  const handleGuardarProgramacion = async () => {
    const EMAIL_VALIDO_RE = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;
    const correos = progForm.destinatarios.split(/[,;\n]+/).map((c) => c.trim()).filter(Boolean);
    const correosCc = (progForm.correos_cc || "").split(/[,;\n]+/).map((c) => c.trim()).filter(Boolean);
    const invalidos = [...correos, ...correosCc].filter((c) => !EMAIL_VALIDO_RE.test(c));
    if (!progForm.plantilla_id) {
      toast.error("Seleccione la encuesta (plantilla)");
      return;
    }
    if (invalidos.length > 0) {
      toast.error(`Correos inválidos: ${invalidos.join(" | ")}. Separe cada correo con coma y verifique el formato.`);
      return;
    }
    if (correos.length === 0) {
      toast.error("Indique al menos un correo destinatario válido");
      return;
    }
    setSavingProg(true);
    try {
      const payload = {
        plantilla_id: progForm.plantilla_id,
        destinatarios: correos,
        correos_cc: correosCc,
        modo: progForm.modo,
        dia_envio: parseInt(progForm.dia_envio, 10) || 1,
        hora_envio: progForm.hora_envio || "08:00",
        corte: progForm.corte,
        activo: progForm.activo
      };
      if (editingProg) {
        await axios.put(`${API}/encuestas/reportes-estadisticos/programaciones/${editingProg.id}`, payload, getAuthHeaders());
        toast.success("Programación actualizada");
      } else {
        await axios.post(`${API}/encuestas/reportes-estadisticos/programaciones`, payload, getAuthHeaders());
        toast.success("Programación creada");
      }
      setShowProgDialog(false);
      fetchReportesConfig();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al guardar la programación");
    } finally {
      setSavingProg(false);
    }
  };

  const handleEliminarProgramacion = async (prog) => {
    if (!confirm(`¿Eliminar la programación del reporte de "${prog.plantilla_nombre}"?`)) return;
    try {
      await axios.delete(`${API}/encuestas/reportes-estadisticos/programaciones/${prog.id}`, getAuthHeaders());
      toast.success("Programación eliminada");
      fetchReportesConfig();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al eliminar");
    }
  };

  const handleToggleProgActivo = async (prog) => {
    try {
      await axios.put(`${API}/encuestas/reportes-estadisticos/programaciones/${prog.id}`, {
        plantilla_id: prog.plantilla_id,
        destinatarios: prog.destinatarios || [],
        modo: prog.modo || "automatico",
        dia_envio: prog.dia_envio ?? 1,
        hora_envio: prog.hora_envio || "08:00",
        corte: prog.corte || "mes_anterior",
        activo: !(prog.activo !== false)
      }, getAuthHeaders());
      fetchReportesConfig();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cambiar estado");
    }
  };

  const handleEnviarAhoraProg = async (prog) => {
    setEnviandoAhoraId(prog.id);
    try {
      const res = await axios.post(`${API}/encuestas/reportes-estadisticos/programaciones/${prog.id}/enviar-ahora`, {}, getAuthHeaders());
      toast.success(res.data.message || "Reporte enviado");
      fetchReportesConfig();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar el reporte");
    } finally {
      setEnviandoAhoraId(null);
    }
  };

  const handleEnviarPruebaMensual = async () => {
    if (!pruebaMensualEmail || !pruebaMensualEmail.includes("@")) {
      toast.error("Indique un correo válido para la prueba");
      return;
    }
    setEnviandoPruebaMensual(true);
    try {
      const res = await axios.post(`${API}/encuestas/reportes-estadisticos/programaciones/${pruebaMensualProg.id}/enviar-prueba`, {
        email: pruebaMensualEmail
      }, getAuthHeaders());
      toast.success(res.data.message || "Correo de prueba enviado");
      setShowPruebaMensualDialog(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al enviar el correo de prueba");
    } finally {
      setEnviandoPruebaMensual(false);
    }
  };

  const handleCerrarMasivo = async () => {
    if (selectedCampanas.length === 0) return;
    setProcessingBulk(true);
    try {
      await axios.post(
        `${API}/encuestas/campanas/cerrar-masivo`,
        { campana_ids: selectedCampanas },
        getAuthHeaders()
      );
      toast.success(`${selectedCampanas.length} encuestas cerradas`);
      setSelectedCampanas([]);
      setShowConfirmCerrar(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cerrar encuestas");
    } finally {
      setProcessingBulk(false);
    }
  };

  const handleReabrirCampana = async (campanaId) => {
    try {
      await axios.post(
        `${API}/encuestas/campanas/${campanaId}/reabrir`,
        {},
        getAuthHeaders()
      );
      toast.success("Encuesta reabierta correctamente");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al reabrir encuesta");
    }
  };

  const handleEliminarMasivo = async () => {
    if (selectedCampanas.length === 0) return;
    
    setProcessingBulk(true);
    try {
      await axios.post(
        `${API}/encuestas/campanas/eliminar-masivo`,
        { campana_ids: selectedCampanas },
        getAuthHeaders()
      );
      toast.success(`${selectedCampanas.length} encuestas eliminadas`);
      setSelectedCampanas([]);
      setShowConfirmEliminar(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al eliminar encuestas");
    } finally {
      setProcessingBulk(false);
    }
  };

  // ============ FUNCIONES DE ANÁLISIS DE ENCUESTA ============
  
  const [respuestasInd, setRespuestasInd] = useState(null);
  const [respuestasIndLoading, setRespuestasIndLoading] = useState(false);
  const [showRespuestasInd, setShowRespuestasInd] = useState(false);

  const handleVerRespuestasInd = async () => {
    if (!selectedCampana) return;
    if (respuestasInd) {
      setShowRespuestasInd(v => !v);
      return;
    }
    setRespuestasIndLoading(true);
    try {
      const res = await axios.get(
        `${API}/encuestas/campanas/${selectedCampana.id}/respuestas-individuales`,
        getAuthHeaders()
      );
      setRespuestasInd(res.data);
      setShowRespuestasInd(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cargar respuestas individuales");
    } finally {
      setRespuestasIndLoading(false);
    }
  };

  const handleOpenAnalisis = async (campana) => {
    setSelectedCampana(campana);
    setShowAnalisisDialog(true);
    setAnalisisLoading(true);
    setRespuestasInd(null);
    setShowRespuestasInd(false);
    
    try {
      const res = await axios.get(
        `${API}/encuestas/campanas/${campana.id}/analisis`,
        getAuthHeaders()
      );
      setAnalisisData(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cargar análisis");
      setShowAnalisisDialog(false);
    } finally {
      setAnalisisLoading(false);
    }
  };

  const handleExportarAnalisisExcel = async () => {
    if (!selectedCampana) return;
    setExportingAnalisis(true);
    
    try {
      const res = await axios.get(
        `${API}/encuestas/campanas/${selectedCampana.id}/analisis/exportar-excel`,
        {
          ...getAuthHeaders(),
          responseType: 'blob'
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `analisis_${selectedCampana.nombre.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("Análisis exportado a Excel");
    } catch (err) {
      toast.error("Error al exportar a Excel");
    } finally {
      setExportingAnalisis(false);
    }
  };

  const handleExportarAnalisisPDF = async () => {
    if (!selectedCampana) return;
    setExportingAnalisis(true);
    
    try {
      const res = await axios.get(
        `${API}/encuestas/campanas/${selectedCampana.id}/analisis/exportar-pdf`,
        {
          ...getAuthHeaders(),
          responseType: 'blob'
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `analisis_${selectedCampana.nombre.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("Análisis exportado a PDF");
    } catch (err) {
      toast.error("Error al exportar a PDF");
    } finally {
      setExportingAnalisis(false);
    }
  };

  const handleExportarRespuestasExcel = async () => {
    if (!selectedCampana) return;
    setExportingAnalisis(true);
    
    try {
      const res = await axios.get(
        `${API}/encuestas/campanas/${selectedCampana.id}/respuestas/exportar-excel`,
        {
          ...getAuthHeaders(),
          responseType: 'blob'
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `respuestas_${selectedCampana.nombre.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("Respuestas exportadas a Excel");
    } catch (err) {
      console.error("Error exportando respuestas:", err);
      toast.error("Error al exportar respuestas");
    } finally {
      setExportingAnalisis(false);
    }
  };

  // Filtrar campañas por estado
  const campanasActivas = campanas.filter(c => c.estado !== "cerrada");
  const campanasCerradas = campanas.filter(c => c.estado === "cerrada");
  const campanasToShow = activeTab === "activas" ? campanasActivas : campanasCerradas;

  const toggleCampoRequerido = (campoId) => {
    const campos = formData.campos_requeridos.includes(campoId)
      ? formData.campos_requeridos.filter(c => c !== campoId)
      : [...formData.campos_requeridos, campoId];
    setFormData({ ...formData, campos_requeridos: campos });
  };

  const getEstadoBadge = (estado) => {
    const estados = {
      borrador: { label: "Borrador", variant: "secondary" },
      activa: { label: "Activa", variant: "default" },
      pausada: { label: "Pausada", variant: "outline" },
      completada: { label: "Completada", variant: "success" },
      cerrada: { label: "Cerrada", variant: "destructive" }
    };
    return estados[estado] || estados.borrador;
  };

  // ====== Vistas alternativas de campañas (tarjetas / lista) ======
  const renderMenuAcciones = (campana, esCerrada) => (
    !soloLectura && (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8" data-testid={`menu-campana-${campana.id}`}>
            <MoreVertical className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => openView(campana)}>
            <Eye className="w-4 h-4 mr-2" />
            Ver Detalles
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleOpenAnalisis(campana)}>
            <BarChart3 className="w-4 h-4 mr-2" />
            Analizar Encuesta
          </DropdownMenuItem>
          {!esCerrada && (
            <DropdownMenuItem onClick={() => openEdit(campana)}>
              <Pencil className="w-4 h-4 mr-2" />
              Editar
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={() => handleClonar(campana)}>
            <Copy className="w-4 h-4 mr-2" />
            Clonar
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {!esCerrada && (campana.estado === "pausada" ? (
            <DropdownMenuItem onClick={() => handleReactivarCampana(campana.id)} data-testid={`reactivar-campana-${campana.id}`}>
              <Play className="w-4 h-4 mr-2" />
              Activar Encuesta
            </DropdownMenuItem>
          ) : (
            <DropdownMenuItem onClick={() => handlePausarCampana(campana.id)} data-testid={`pausar-campana-${campana.id}`}>
              <Pause className="w-4 h-4 mr-2" />
              Inactivar Encuesta
            </DropdownMenuItem>
          ))}
          <DropdownMenuItem
            className="text-amber-600"
            onClick={() => { setCampanaBorrarStats(campana); setShowConfirmBorrarStats(true); }}
            data-testid={`borrar-stats-${campana.id}`}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Borrar Estadísticas
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {esCerrada ? (
            <DropdownMenuItem onClick={() => handleReabrirCampana(campana.id)}>
              <Play className="w-4 h-4 mr-2" />
              Reabrir Encuesta
            </DropdownMenuItem>
          ) : (
            <DropdownMenuItem onClick={() => handleCerrarCampana(campana.id)}>
              <CheckCircle className="w-4 h-4 mr-2" />
              Cerrar Encuesta
            </DropdownMenuItem>
          )}
          {esCerrada && campana.es_historico && (
            <DropdownMenuItem className="text-destructive" onClick={() => handleDeshacerImportacion(campana)}>
              <Trash2 className="w-4 h-4 mr-2" />
              Deshacer importación
            </DropdownMenuItem>
          )}
          <DropdownMenuItem className="text-destructive" onClick={() => handleDelete(campana.id)}>
            <Trash2 className="w-4 h-4 mr-2" />
            Eliminar
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  );

  const npsCampana = (c) => (c.nps === null || c.nps === undefined ? "—" : c.nps);
  // Semáforo: verde si NPS >= meta (60), rojo si queda por debajo
  const npsClase = (c) => (c.nps === null || c.nps === undefined
    ? "text-muted-foreground"
    : c.nps >= (c.meta_nps ?? 60) ? "text-green-600" : "text-red-600");

  // ====== Filtro de campañas por ejecutivo o nombre (aplica a las 3 vistas) ======
  const normalizarTexto = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const filtrarCampanas = (lista) => {
    const q = normalizarTexto(filtroCampanas.trim());
    if (!q) return lista;
    return lista.filter((c) =>
      normalizarTexto(c.nombre).includes(q) ||
      normalizarTexto(c.ejecutivo_encuestar_nombre).includes(q) ||
      normalizarTexto(c.encuesta_nombre).includes(q)
    );
  };
  const campanasActivasFiltradas = filtrarCampanas(campanasActivas);
  const campanasCerradasFiltradas = filtrarCampanas(campanasCerradas);

  const renderVistaTarjetas = (campanas, esCerrada) => (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid={`vista-tarjetas-${esCerrada ? "cerradas" : "activas"}`}>
      {campanas.map((campana) => {
        const estadoInfo = getEstadoBadge(campana.estado);
        const isSelected = selectedCampanas.includes(campana.id);
        return (
          <Card key={campana.id} className={`transition-all ${isSelected ? "ring-2 ring-primary" : ""}`} data-testid={`tarjeta-campana-${campana.id}`}>
            <CardContent className="p-4 space-y-3">
              <div className="flex items-start gap-2">
                <Checkbox checked={isSelected} onCheckedChange={() => toggleSelectCampana(campana.id)} className="mt-1" />
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold truncate" title={campana.nombre}>{campana.nombre}</h3>
                  <div className="flex items-center gap-1 flex-wrap mt-1">
                    <Badge variant={estadoInfo.variant}>{estadoInfo.label}</Badge>
                    {!esCerrada && campana.tipo_envio === "programado" && (
                      <Badge variant="outline" className="gap-1"><Calendar className="w-3 h-3" />Programada</Badge>
                    )}
                    {esCerrada && campana.es_historico && (
                      <Badge className="bg-amber-100 text-amber-800 border border-amber-300 hover:bg-amber-100">HISTÓRICO</Badge>
                    )}
                  </div>
                </div>
                {renderMenuAcciones(campana, esCerrada)}
              </div>
              <div className="rounded-md bg-slate-100 dark:bg-slate-800 px-3 py-2">
                <span className="text-[11px] text-muted-foreground block">Ejecutivo a encuestar</span>
                <span className="text-sm font-semibold" data-testid={`tarjeta-ejecutivo-${campana.id}`}>{campana.ejecutivo_encuestar_nombre || "-"}</span>
              </div>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div>
                  <div className="text-lg font-bold">{campana.total_destinatarios || 0}</div>
                  <div className="text-[10px] text-muted-foreground">Destinatarios</div>
                </div>
                <div>
                  <div className="text-lg font-bold text-green-600">{campana.total_respondidos || 0}</div>
                  <div className="text-[10px] text-muted-foreground">Respondidos</div>
                </div>
                <div>
                  <div className={`text-lg font-bold ${npsClase(campana)}`}>{npsCampana(campana)}</div>
                  <div className="text-[10px] text-muted-foreground">NPS</div>
                </div>
              </div>
              <Button variant="outline" size="sm" className="w-full" onClick={() => openDestinatarios(campana)}>
                {esCerrada ? <Eye className="w-4 h-4 mr-1" /> : <Users className="w-4 h-4 mr-1" />}
                {esCerrada ? "Ver Resultados" : "Destinatarios"}
              </Button>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );

  const renderVistaLista = (campanas, esCerrada) => (
    <Card>
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid={`vista-lista-${esCerrada ? "cerradas" : "activas"}`}>
          <thead className="bg-slate-100 dark:bg-slate-800">
            <tr>
              <th className="p-3 w-8"></th>
              <th className="p-3 text-left text-xs font-medium text-slate-500 uppercase">Campaña</th>
              <th className="p-3 text-left text-xs font-medium text-slate-500 uppercase">Ejecutivo a encuestar</th>
              <th className="p-3 text-left text-xs font-medium text-slate-500 uppercase">Estado</th>
              <th className="p-3 text-center text-xs font-medium text-slate-500 uppercase">Destinatarios</th>
              <th className="p-3 text-center text-xs font-medium text-slate-500 uppercase">Respondidos</th>
              <th className="p-3 text-center text-xs font-medium text-slate-500 uppercase">NPS</th>
              <th className="p-3 text-center text-xs font-medium text-slate-500 uppercase">{esCerrada ? "Cerrada" : "Sin enviar"}</th>
              <th className="p-3 text-left text-xs font-medium text-slate-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {campanas.map((campana) => {
              const estadoInfo = getEstadoBadge(campana.estado);
              const isSelected = selectedCampanas.includes(campana.id);
              return (
                <tr key={campana.id} className={isSelected ? "bg-primary/5" : ""} data-testid={`fila-campana-${campana.id}`}>
                  <td className="p-3">
                    <Checkbox checked={isSelected} onCheckedChange={() => toggleSelectCampana(campana.id)} />
                  </td>
                  <td className="p-3">
                    <div className="font-medium">{campana.nombre}</div>
                    <div className="text-xs text-muted-foreground truncate max-w-[280px]" title={campana.encuesta_nombre}>{campana.encuesta_nombre || "Sin asignar"}</div>
                  </td>
                  <td className="p-3 font-medium" data-testid={`lista-ejecutivo-${campana.id}`}>{campana.ejecutivo_encuestar_nombre || "-"}</td>
                  <td className="p-3">
                    <div className="flex items-center gap-1 flex-wrap">
                      <Badge variant={estadoInfo.variant}>{estadoInfo.label}</Badge>
                      {!esCerrada && campana.tipo_envio === "programado" && (
                        <Badge variant="outline" className="gap-1"><Calendar className="w-3 h-3" />Programada</Badge>
                      )}
                      {esCerrada && campana.es_historico && (
                        <Badge className="bg-amber-100 text-amber-800 border border-amber-300 hover:bg-amber-100">HISTÓRICO</Badge>
                      )}
                    </div>
                  </td>
                  <td className="p-3 text-center">{campana.total_destinatarios || 0}</td>
                  <td className="p-3 text-center text-green-600 font-semibold">{campana.total_respondidos || 0}</td>
                  <td className={`p-3 text-center font-semibold ${npsClase(campana)}`}>{npsCampana(campana)}</td>
                  <td className="p-3 text-center">
                    {esCerrada
                      ? (campana.fecha_cierre ? new Date(campana.fecha_cierre).toLocaleDateString() : "-")
                      : <span className={(campana.total_pendientes || 0) > 0 ? "text-amber-600 font-semibold" : "text-muted-foreground"}>{campana.total_pendientes || 0}</span>}
                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-1">
                      <Button variant="outline" size="sm" onClick={() => openDestinatarios(campana)}>
                        {esCerrada ? <Eye className="w-4 h-4 mr-1" /> : <Users className="w-4 h-4 mr-1" />}
                        {esCerrada ? "Ver Resultados" : "Destinatarios"}
                      </Button>
                      {renderMenuAcciones(campana, esCerrada)}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
      <Sidebar />
      <main className="flex-1 ml-0 md:ml-64 p-4 md:p-6 pt-14 md:pt-6 space-y-6" data-testid="encuestas-campanas-page">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Send className="w-6 h-6" />
            Gestión de Encuestas
          </h1>
          <p className="text-muted-foreground">Gestione el envío de encuestas a sus clientes</p>
        </div>
        {!soloLectura && (
          <Button onClick={() => { resetForm(); setShowDialog(true); }} data-testid="nueva-campana-btn">
            <Plus className="w-4 h-4 mr-2" />
            Nueva Campaña
          </Button>
        )}
      </div>

      {/* Pestañas Activas / Cerradas */}
      <Tabs value={activeTab} onValueChange={(v) => { setActiveTab(v); setSelectedCampanas([]); if (v === "reportes") fetchReportesConfig(); if (v === "cargar-historial") fetchHistUsuarios(); }}>
        <div className="flex items-center justify-between">
          <TabsList>
            <TabsTrigger value="activas" className="flex items-center gap-2">
              <Play className="w-4 h-4" />
              Encuestas Activas
              <Badge variant="secondary" className="ml-1">{campanasActivas.length}</Badge>
            </TabsTrigger>
            <TabsTrigger value="cerradas" className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4" />
              Encuestas Cerradas
              <Badge variant="secondary" className="ml-1">{campanasCerradas.length}</Badge>
            </TabsTrigger>
            {!soloLectura && (
              <TabsTrigger value="reportes" className="flex items-center gap-2" data-testid="tab-reportes-estadisticos">
                <FileText className="w-4 h-4" />
                Envío de reportes estadísticos
              </TabsTrigger>
            )}
            {!soloLectura && (
              <TabsTrigger value="cargar-historial" className="flex items-center gap-2" data-testid="tab-cargar-historial">
                <Upload className="w-4 h-4" />
                Cargar Historial
              </TabsTrigger>
            )}
          </TabsList>
          
          {/* Selector de vista + Acciones masivas */}
          <div className="flex items-center gap-3">
            {!soloLectura && selectedCampanas.length > 0 && (
              <div className="flex items-center gap-2">
                <span className="text-sm text-muted-foreground">
                  {selectedCampanas.length} seleccionada(s)
                </span>
                {activeTab === "activas" && (
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => setShowConfirmCerrar(true)}
                  >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Cerrar Seleccionadas
                  </Button>
                )}
                <Button 
                  variant="destructive" 
                  size="sm"
                  onClick={() => setShowConfirmEliminar(true)}
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Eliminar Seleccionadas
                </Button>
              </div>
            )}
            {(activeTab === "activas" || activeTab === "cerradas") && (
              <div className="relative">
                <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
                <Input
                  value={filtroCampanas}
                  onChange={(e) => setFiltroCampanas(e.target.value)}
                  placeholder="Buscar por ejecutivo o nombre..."
                  className="pl-8 h-8 w-64"
                  data-testid="filtro-campanas-input"
                />
              </div>
            )}
            {(activeTab === "activas" || activeTab === "cerradas") && (
              <div className="flex items-center rounded-md border bg-white dark:bg-slate-800 p-0.5" data-testid="selector-vista-campanas">
                {[
                  { v: "detallada", Icon: Rows3, label: "Vista detallada" },
                  { v: "tarjetas", Icon: LayoutGrid, label: "Vista de tarjetas" },
                  { v: "lista", Icon: List, label: "Vista de lista" },
                ].map(({ v, Icon, label }) => (
                  <Button
                    key={v}
                    variant={vistaCampanas === v ? "secondary" : "ghost"}
                    size="sm"
                    className="h-7 px-2"
                    onClick={() => cambiarVistaCampanas(v)}
                    title={label}
                    data-testid={`vista-btn-${v}`}
                  >
                    <Icon className="w-4 h-4" />
                  </Button>
                ))}
              </div>
            )}
          </div>
        </div>

        <TabsContent value="activas" className="mt-4">
          {campanasActivas.length === 0 ? (
            <Card>
              <CardContent className="flex flex-col items-center justify-center py-12">
                <Mail className="w-12 h-12 text-muted-foreground mb-4" />
                <h3 className="text-lg font-medium mb-2">No hay encuestas activas</h3>
                <p className="text-muted-foreground mb-4">Cree su primera campaña para comenzar a enviar encuestas</p>
                <Button onClick={() => setShowDialog(true)}>
                  <Plus className="w-4 h-4 mr-2" />
                  Crear Campaña
                </Button>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-3">
              {/* Seleccionar todos */}
              <div className="flex items-center gap-2 px-2">
                <Checkbox
                  id="select-all-activas"
                  checked={selectedCampanas.length === campanasActivasFiltradas.length && campanasActivasFiltradas.length > 0}
                  onCheckedChange={() => toggleSelectAll(campanasActivasFiltradas)}
                />
                <Label htmlFor="select-all-activas" className="text-sm cursor-pointer">
                  Seleccionar todas
                </Label>
              </div>
              
              {filtroCampanas && campanasActivasFiltradas.length === 0 && (
                <p className="text-sm text-muted-foreground text-center py-8" data-testid="filtro-sin-resultados-activas">
                  No hay campañas que coincidan con "{filtroCampanas}"
                </p>
              )}
              {vistaCampanas === "tarjetas" && renderVistaTarjetas(campanasActivasFiltradas, false)}
              {vistaCampanas === "lista" && campanasActivasFiltradas.length > 0 && renderVistaLista(campanasActivasFiltradas, false)}
              {vistaCampanas === "detallada" && campanasActivasFiltradas.map((campana) => {
                const estadoInfo = getEstadoBadge(campana.estado);
                const isSelected = selectedCampanas.includes(campana.id);
                return (
                  <Card key={campana.id} className={`transition-all ${isSelected ? 'ring-2 ring-primary' : ''}`}>
                    <CardContent className="p-4">
                      <div className="flex flex-wrap sm:flex-nowrap items-start gap-3 sm:gap-4">
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => toggleSelectCampana(campana.id)}
                          className="mt-1"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-2 flex-wrap">
                            <h3 className="text-lg font-semibold break-words">{campana.nombre}</h3>
                            <Badge variant={estadoInfo.variant}>{estadoInfo.label}</Badge>
                            {campana.tipo_envio === "programado" && (
                              <Badge variant="outline" className="gap-1">
                                <Calendar className="w-3 h-3" />
                                Programada
                              </Badge>
                            )}
                          </div>
                          <p className="text-sm text-muted-foreground mb-3">
                            Encuesta: {campana.encuesta_nombre || "Sin asignar"}
                          </p>
                          
                          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 mb-3">
                            <div className="text-center">
                              <div className="text-2xl font-bold">{campana.total_destinatarios || 0}</div>
                              <div className="text-xs text-muted-foreground">Destinatarios</div>
                            </div>
                            <div className="text-center">
                              <div className="text-2xl font-bold text-green-600">{campana.total_respondidos || 0}</div>
                              <div className="text-xs text-muted-foreground">Respondidos</div>
                            </div>
                            <div className="text-center">
                              <div className={`text-2xl font-bold ${npsClase(campana)}`} data-testid={`campana-nps-${campana.id}`}>
                                {npsCampana(campana)}
                              </div>
                              <div className="text-xs text-muted-foreground">NPS</div>
                            </div>
                            <div className="text-center">
                              <div
                                className={`text-2xl font-bold ${(campana.total_pendientes || 0) > 0 ? "text-amber-600" : "text-muted-foreground"}`}
                                data-testid={`campana-sin-enviar-${campana.id}`}
                              >
                                {campana.total_pendientes || 0}
                              </div>
                              <div className="text-xs text-muted-foreground">Sin enviar</div>
                              {campana.fecha_envio_real && (
                                <div className="text-[10px] text-muted-foreground">
                                  Enviado {new Date(campana.fecha_envio_real).toLocaleDateString()}
                                </div>
                              )}
                            </div>
                          </div>
                          {(campana.ejecutivo_encuestar_nombre || campana.renovacion_mes || campana.reclamo_mes || campana.muestras_minimas != null) && (
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-1 pt-2 border-t" data-testid={`campana-extra-${campana.id}`}>
                              <div>
                                <span className="text-xs text-muted-foreground block">{campana.reclamo_mes ? "Mes del reclamo encuestado" : "Mes de renovación a encuestar"}</span>
                                <span className="text-sm font-medium">{campana.reclamo_mes ? `${nombreMes(campana.reclamo_mes)} ${campana.reclamo_anio || ''}`.trim() : (campana.renovacion_mes ? `${nombreMes(campana.renovacion_mes)} ${campana.renovacion_anio || ''}`.trim() : '-')}</span>
                              </div>
                              <div>
                                <span className="text-xs text-muted-foreground block">Ejecutivo a encuestar</span>
                                <span className="text-sm font-medium">{campana.ejecutivo_encuestar_nombre || '-'}</span>
                              </div>
                              <div>
                                <span className="text-xs text-muted-foreground block">Muestras mínimas</span>
                                <span className="text-sm font-medium">{campana.muestras_minimas != null ? `${campana.total_respondidos || 0} / ${campana.muestras_minimas}` : '-'}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        
                        <div className="flex items-center gap-2 w-full sm:w-auto justify-end flex-wrap">
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => openDestinatarios(campana)}
                          >
                            <Users className="w-4 h-4 mr-1" />
                            Destinatarios
                          </Button>
                          {!soloLectura && (
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button variant="ghost" size="icon">
                                <MoreVertical className="w-4 h-4" />
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                              <DropdownMenuItem onClick={() => openView(campana)}>
                                <Eye className="w-4 h-4 mr-2" />
                                Ver Detalles
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => handleOpenAnalisis(campana)}>
                                <BarChart3 className="w-4 h-4 mr-2" />
                                Analizar Encuesta
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => openEdit(campana)}>
                                <Pencil className="w-4 h-4 mr-2" />
                                Editar
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => handleClonar(campana)}>
                                <Copy className="w-4 h-4 mr-2" />
                                Clonar
                              </DropdownMenuItem>
                              <DropdownMenuSeparator />
                              {campana.estado === "pausada" ? (
                                <DropdownMenuItem onClick={() => handleReactivarCampana(campana.id)} data-testid={`reactivar-campana-${campana.id}`}>
                                  <Play className="w-4 h-4 mr-2" />
                                  Activar Encuesta
                                </DropdownMenuItem>
                              ) : (
                                <DropdownMenuItem onClick={() => handlePausarCampana(campana.id)} data-testid={`pausar-campana-${campana.id}`}>
                                  <Pause className="w-4 h-4 mr-2" />
                                  Inactivar Encuesta
                                </DropdownMenuItem>
                              )}
                              <DropdownMenuItem 
                                className="text-amber-600"
                                onClick={() => { setCampanaBorrarStats(campana); setShowConfirmBorrarStats(true); }}
                                data-testid={`borrar-stats-${campana.id}`}
                              >
                                <RefreshCw className="w-4 h-4 mr-2" />
                                Borrar Estadísticas
                              </DropdownMenuItem>
                              <DropdownMenuSeparator />
                              <DropdownMenuItem onClick={() => handleCerrarCampana(campana.id)}>
                                <CheckCircle className="w-4 h-4 mr-2" />
                                Cerrar Encuesta
                              </DropdownMenuItem>
                              <DropdownMenuItem 
                                className="text-destructive"
                                onClick={() => handleDelete(campana.id)}
                              >
                                <Trash2 className="w-4 h-4 mr-2" />
                                Eliminar
                              </DropdownMenuItem>
                            </DropdownMenuContent>
                          </DropdownMenu>
                          )}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}
        </TabsContent>

        <TabsContent value="cerradas" className="mt-4">
          {campanasCerradas.length === 0 ? (
            <Card>
              <CardContent className="flex flex-col items-center justify-center py-12">
                <CheckCircle className="w-12 h-12 text-muted-foreground mb-4" />
                <h3 className="text-lg font-medium mb-2">No hay encuestas cerradas</h3>
                <p className="text-muted-foreground">Las encuestas cerradas aparecerán aquí</p>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-3">
              {/* Seleccionar todos */}
              <div className="flex items-center gap-2 px-2">
                <Checkbox
                  id="select-all-cerradas"
                  checked={selectedCampanas.length === campanasCerradasFiltradas.length && campanasCerradasFiltradas.length > 0}
                  onCheckedChange={() => toggleSelectAll(campanasCerradasFiltradas)}
                />
                <Label htmlFor="select-all-cerradas" className="text-sm cursor-pointer">
                  Seleccionar todas
                </Label>
              </div>
              
              {filtroCampanas && campanasCerradasFiltradas.length === 0 && (
                <p className="text-sm text-muted-foreground text-center py-8" data-testid="filtro-sin-resultados-cerradas">
                  No hay campañas que coincidan con "{filtroCampanas}"
                </p>
              )}
              {vistaCampanas === "tarjetas" && renderVistaTarjetas(campanasCerradasFiltradas, true)}
              {vistaCampanas === "lista" && campanasCerradasFiltradas.length > 0 && renderVistaLista(campanasCerradasFiltradas, true)}
              {vistaCampanas === "detallada" && campanasCerradasFiltradas.map((campana) => {
                const estadoInfo = getEstadoBadge(campana.estado);
                const isSelected = selectedCampanas.includes(campana.id);
                return (
                  <Card key={campana.id} className={`transition-all ${isSelected ? 'ring-2 ring-primary' : ''}`}>
                    <CardContent className="p-4">
                      <div className="flex flex-wrap sm:flex-nowrap items-start gap-3 sm:gap-4">
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => toggleSelectCampana(campana.id)}
                          className="mt-1"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-2 flex-wrap">
                            <h3 className="text-lg font-semibold break-words">{campana.nombre}</h3>
                            <Badge variant={estadoInfo.variant}>{estadoInfo.label}</Badge>
                            {campana.es_historico && (
                              <Badge className="bg-amber-100 text-amber-800 border border-amber-300 hover:bg-amber-100" data-testid={`badge-historico-${campana.id}`}>
                                HISTÓRICO
                              </Badge>
                            )}
                          </div>
                          <p className="text-sm text-muted-foreground mb-3">
                            Encuesta: {campana.encuesta_nombre || "Sin asignar"}
                          </p>
                          
                          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 mb-3">
                            <div className="text-center">
                              <div className="text-2xl font-bold">{campana.total_destinatarios || 0}</div>
                              <div className="text-xs text-muted-foreground">Destinatarios</div>
                            </div>
                            <div className="text-center">
                              <div className="text-2xl font-bold text-green-600">{campana.total_respondidos || 0}</div>
                              <div className="text-xs text-muted-foreground">Respondidos</div>
                            </div>
                            <div className="text-center">
                              <div className={`text-2xl font-bold ${npsClase(campana)}`} data-testid={`campana-nps-${campana.id}`}>
                                {npsCampana(campana)}
                              </div>
                              <div className="text-xs text-muted-foreground">NPS</div>
                            </div>
                            <div className="text-center">
                              <div className="text-xs text-muted-foreground mb-1">Cerrada</div>
                              <div className="text-xs">
                                {campana.fecha_cierre 
                                  ? new Date(campana.fecha_cierre).toLocaleDateString()
                                  : "-"}
                              </div>
                            </div>
                          </div>
                          {(campana.ejecutivo_encuestar_nombre || campana.renovacion_mes || campana.reclamo_mes || campana.muestras_minimas != null) && (
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-1 pt-2 border-t" data-testid={`campana-extra-${campana.id}`}>
                              <div>
                                <span className="text-xs text-muted-foreground block">{campana.reclamo_mes ? "Mes del reclamo encuestado" : "Mes de renovación a encuestar"}</span>
                                <span className="text-sm font-medium">{campana.reclamo_mes ? `${nombreMes(campana.reclamo_mes)} ${campana.reclamo_anio || ''}`.trim() : (campana.renovacion_mes ? `${nombreMes(campana.renovacion_mes)} ${campana.renovacion_anio || ''}`.trim() : '-')}</span>
                              </div>
                              <div>
                                <span className="text-xs text-muted-foreground block">Ejecutivo a encuestar</span>
                                <span className="text-sm font-medium">{campana.ejecutivo_encuestar_nombre || '-'}</span>
                              </div>
                              <div>
                                <span className="text-xs text-muted-foreground block">Muestras mínimas</span>
                                <span className="text-sm font-medium">{campana.muestras_minimas != null ? `${campana.total_respondidos || 0} / ${campana.muestras_minimas}` : '-'}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        
                        <div className="flex items-center gap-2 w-full sm:w-auto justify-end flex-wrap">
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => openDestinatarios(campana)}
                          >
                            <Eye className="w-4 h-4 mr-1" />
                            Ver Resultados
                          </Button>
                          {!soloLectura && campana.es_historico && (
                            <Button
                              variant="destructive"
                              size="sm"
                              onClick={() => handleDeshacerImportacion(campana)}
                              data-testid={`deshacer-importacion-${campana.id}`}
                            >
                              <Trash2 className="w-4 h-4 mr-1" />
                              Deshacer importación
                            </Button>
                          )}
                          {!soloLectura && (
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button variant="ghost" size="icon">
                                <MoreVertical className="w-4 h-4" />
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                              <DropdownMenuItem onClick={() => openView(campana)}>
                                <Eye className="w-4 h-4 mr-2" />
                                Ver Detalles
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => handleOpenAnalisis(campana)}>
                                <BarChart3 className="w-4 h-4 mr-2" />
                                Analizar Encuesta
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => handleClonar(campana)}>
                                <Copy className="w-4 h-4 mr-2" />
                                Clonar
                              </DropdownMenuItem>
                              <DropdownMenuSeparator />
                              <DropdownMenuItem 
                                className="text-amber-600"
                                onClick={() => { setCampanaBorrarStats(campana); setShowConfirmBorrarStats(true); }}
                              >
                                <RefreshCw className="w-4 h-4 mr-2" />
                                Borrar Estadísticas
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => handleReabrirCampana(campana.id)}>
                                <Play className="w-4 h-4 mr-2" />
                                Reabrir Encuesta
                              </DropdownMenuItem>
                              <DropdownMenuItem 
                                className="text-destructive"
                                onClick={() => handleDelete(campana.id)}
                              >
                                <Trash2 className="w-4 h-4 mr-2" />
                                Eliminar
                              </DropdownMenuItem>
                            </DropdownMenuContent>
                          </DropdownMenu>
                          )}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}
        </TabsContent>

        {/* Pestaña Envío de reportes estadísticos */}
        <TabsContent value="cargar-historial" className="mt-4">
          <Card data-testid="cargar-historial-card">
            <CardHeader>
              <CardTitle>Cargar Historial de Encuestas</CardTitle>
              <CardDescription>
                Importe las encuestas de la plataforma anterior. Se crean como campaña <strong>cerrada</strong> con la fecha original de cada respuesta (el NPS histórico se calcula por mes). No se envía ningún correo ni alerta.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                <div className="space-y-2">
                  <Label>Plantilla destino</Label>
                  <Select value={histPlantillaId} onValueChange={setHistPlantillaId}>
                    <SelectTrigger data-testid="hist-plantilla-select">
                      <SelectValue placeholder="Seleccione la plantilla" />
                    </SelectTrigger>
                    <SelectContent>
                      {plantillas.map((p) => (
                        <SelectItem key={p.id} value={p.id}>{p.nombre}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label>Archivo del historial (.xlsx o .csv)</Label>
                  <Input
                    type="file"
                    accept=".xlsx,.csv"
                    onChange={(e) => setHistFile(e.target.files?.[0] || null)}
                    data-testid="hist-file-input"
                  />
                </div>
                <Button onClick={handleAnalizarHistorial} disabled={histLoading} data-testid="hist-analizar-btn">
                  {histLoading && !histAnalisis ? "Analizando..." : "Analizar archivo"}
                </Button>
              </div>

              {histAnalisis && (
                <div className="space-y-6" data-testid="hist-mapeo-section">
                  <div className="p-3 border rounded-lg bg-muted/50 text-sm">
                    <strong>{histAnalisis.total_filas}</strong> filas detectadas. Revise el mapeo sugerido de cada columna: las preguntas que ya no existen puede crearlas como <strong>pregunta histórica</strong> (solo consulta, no sale en futuros envíos).
                  </div>
                  <div className="border rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Columna del archivo</TableHead>
                          <TableHead>Ejemplos</TableHead>
                          <TableHead className="min-w-[320px]">Mapear a</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {histAnalisis.sugerencias.map((s) => (
                          <TableRow key={s.columna}>
                            <TableCell className="font-medium max-w-[280px] whitespace-normal">{s.columna}</TableCell>
                            <TableCell className="text-xs text-muted-foreground max-w-[200px] truncate">
                              {s.ejemplos.filter(Boolean).slice(0, 2).join(" · ")}
                            </TableCell>
                            <TableCell>
                              <Select
                                value={histMapeo[s.columna] || "ignorar"}
                                onValueChange={(v) => setHistMapeo((p) => ({ ...p, [s.columna]: v }))}
                              >
                                <SelectTrigger data-testid={`hist-mapeo-${s.columna}`}>
                                  <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="fecha">📅 Fecha de respuesta</SelectItem>
                                  <SelectItem value="cliente">Nombre del cliente</SelectItem>
                                  <SelectItem value="correo">Correo del cliente</SelectItem>
                                  <SelectItem value="comentario">Comentario general</SelectItem>
                                  <SelectItem value="ignorar">Ignorar columna</SelectItem>
                                  <SelectItem value="nueva_pregunta">➕ Crear como pregunta histórica</SelectItem>
                                  {histAnalisis.preguntas_plantilla.map((p) => (
                                    <SelectItem key={p.id} value={`pregunta::${p.id}`}>
                                      {p.tipo === "nps" ? "⭐ " : ""}{p.pregunta.length > 70 ? p.pregunta.slice(0, 70) + "..." : p.pregunta}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label>Nombre de la campaña histórica</Label>
                      <Input value={histNombre} onChange={(e) => setHistNombre(e.target.value)} data-testid="hist-nombre-input" />
                    </div>
                    <div className="space-y-2">
                      <Label>¿A qué ejecutivo corresponde este historial?</Label>
                      <div className="flex gap-2">
                        <Select value={histEjecutivo} onValueChange={setHistEjecutivo}>
                          <SelectTrigger data-testid="hist-ejecutivo-select" className="flex-1">
                            <SelectValue placeholder="Seleccione un ejecutivo" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="__manual__">✍️ Introducir manualmente (ya no está en la empresa)</SelectItem>
                            {histUsuarios.map((u) => (
                              <SelectItem key={u.id} value={u.name}>{u.name}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      {histEjecutivo === "__manual__" && (
                        <Input
                          value={histEjecutivoManual}
                          onChange={(e) => setHistEjecutivoManual(e.target.value)}
                          placeholder="Nombre del ejecutivo (manual)"
                          data-testid="hist-ejecutivo-manual"
                        />
                      )}
                    </div>
                  </div>

                  <Button onClick={handleImportarHistorial} disabled={histLoading} data-testid="hist-importar-btn">
                    <Upload className="w-4 h-4 mr-2" />
                    {histLoading ? "Importando..." : "Importar historial como campaña cerrada"}
                  </Button>
                </div>
              )}

              {histResultado && (
                <div className="p-4 border border-green-300 rounded-lg bg-green-50 space-y-2" data-testid="hist-resultado">
                  <p className="font-medium text-green-900">✅ {histResultado.message}</p>
                  <p className="text-sm text-green-800">
                    Campaña: <strong>{histResultado.campana_nombre}</strong> · {histResultado.importadas} respuestas importadas
                    {histResultado.errores > 0 && ` · ${histResultado.errores} filas con error (fecha/respuestas inválidas)`}
                    {histResultado.preguntas_historicas_creadas > 0 && ` · ${histResultado.preguntas_historicas_creadas} pregunta(s) histórica(s) creada(s) en la plantilla`}
                  </p>
                  <div className="text-sm text-green-800">
                    <strong>Respuestas por mes:</strong>{" "}
                    {Object.entries(histResultado.por_mes || {}).map(([mes, n]) => `${mes}: ${n}`).join(" | ")}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="reportes" className="mt-4">
          <Card data-testid="reportes-estadisticos-card">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Envío de Reportes Estadísticos
              </CardTitle>
              <CardDescription>
                Configure la alerta automática por NPS bajo y los reportes mensuales estadísticos por encuesta.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              {datosPrueba?.existe && (
                <div className="flex flex-wrap items-center justify-between gap-3 p-4 border border-amber-300 rounded-lg bg-amber-50" data-testid="datos-prueba-section">
                  <div>
                    <p className="font-medium text-amber-900">Datos de prueba NPS ([PRUEBA])</p>
                    <p className="text-sm text-amber-700">
                      {datosPrueba.plantillas} plantilla(s), {datosPrueba.campanas} campaña(s) y {datosPrueba.respuestas} respuestas ficticias. Al borrarlos no se vuelven a crear.
                    </p>
                  </div>
                  <Button
                    variant="destructive"
                    size="sm"
                    disabled={borrandoPrueba}
                    onClick={handleBorrarDatosPrueba}
                    data-testid="borrar-datos-prueba-btn"
                  >
                    <Trash2 className="w-4 h-4 mr-2" />
                    {borrandoPrueba ? "Borrando..." : "Borrar datos de prueba"}
                  </Button>
                </div>
              )}
              <div className="flex items-center justify-between p-4 border rounded-lg bg-muted/50">
                <div className="flex items-center gap-3">
                  <Bell className="w-6 h-6 text-red-600" />
                  <div>
                    <Label htmlFor="reportes-activo" className="text-base font-medium">Alerta automática por NPS bajo</Label>
                    <p className="text-sm text-muted-foreground">
                      Cuando la pregunta NPS #1 reciba una puntuación de {reportesConfig.umbral_nps} o menos, se enviará UN solo correo al ejecutivo encuestado,
                      con copia (CC) al supervisor de su departamento, al padrino de la cuenta (Email Padrino) y a los correos adicionales configurados,
                      con el cuestionario completo adjunto en PDF, sin revelar la identidad del cliente.
                    </p>
                  </div>
                </div>
                <Switch
                  id="reportes-activo"
                  checked={reportesConfig.activo}
                  onCheckedChange={(checked) => setReportesConfig({ ...reportesConfig, activo: checked })}
                  data-testid="reportes-activo-switch"
                />
              </div>

              <div className="flex flex-wrap items-end gap-4">
                <div className="space-y-2">
                  <Label htmlFor="umbral-nps">Puntuación máxima para alertar (0-10)</Label>
                  <Input
                    id="umbral-nps"
                    type="number"
                    min="0"
                    max="10"
                    className="w-32"
                    value={reportesConfig.umbral_nps}
                    onChange={(e) => setReportesConfig({ ...reportesConfig, umbral_nps: e.target.value })}
                    data-testid="umbral-nps-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="meta-nps">Meta NPS (%) — reportes</Label>
                  <Input
                    id="meta-nps"
                    type="number"
                    min="0"
                    max="100"
                    className="w-32"
                    value={reportesConfig.meta_nps}
                    onChange={(e) => setReportesConfig({ ...reportesConfig, meta_nps: e.target.value })}
                    data-testid="meta-nps-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label>Pregunta que dispara la alerta</Label>
                  <Select
                    value={reportesConfig.modo_pregunta}
                    onValueChange={(v) => setReportesConfig({ ...reportesConfig, modo_pregunta: v })}
                  >
                    <SelectTrigger className="w-64" data-testid="modo-pregunta-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="primera_nps">Solo la pregunta #1 (NPS)</SelectItem>
                      <SelectItem value="todas_nps">Cualquier pregunta tipo NPS</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <Button onClick={handleGuardarReportesConfig} disabled={savingReportes} data-testid="guardar-reportes-config-btn">
                  {savingReportes ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle className="w-4 h-4 mr-2" />}
                  Guardar Configuración
                </Button>
              </div>

              <div className="space-y-2">
                <Label htmlFor="correos-adicionales-cc">Correos adicionales en copia (CC) — separados por coma</Label>
                <Textarea
                  id="correos-adicionales-cc"
                  rows={2}
                  placeholder="correo1@empresa.com, correo2@empresa.com"
                  value={reportesConfig.correos_adicionales}
                  onChange={(e) => setReportesConfig({ ...reportesConfig, correos_adicionales: e.target.value })}
                  data-testid="correos-adicionales-cc-input"
                />
                <p className="text-xs text-muted-foreground">Estos correos recibirán la alerta de NPS bajo en copia, junto al supervisor y el padrino. Recuerde presionar "Guardar Configuración".</p>
              </div>

              {/* Envío de prueba de la alerta */}
              <div className="p-4 border rounded-lg space-y-3" data-testid="envio-prueba-section">
                <h3 className="font-semibold flex items-center gap-2">
                  <Send className="w-4 h-4" />
                  Envío de prueba de la alerta
                </h3>
                <p className="text-sm text-muted-foreground">
                  Envíe un correo de prueba para validar cómo se verá la alerta de NPS bajo (con el cuestionario de ejemplo anónimo en PDF) antes de activar la configuración.
                </p>
                <div className="flex flex-wrap items-end gap-4">
                  <div className="space-y-2">
                    <Label>Encuesta (plantilla) del reporte</Label>
                    <Select value={pruebaPlantillaId} onValueChange={setPruebaPlantillaId}>
                      <SelectTrigger className="w-72" data-testid="prueba-plantilla-select">
                        <SelectValue placeholder="Seleccione una encuesta" />
                      </SelectTrigger>
                      <SelectContent>
                        {plantillas.map((p) => (
                          <SelectItem key={p.id} value={p.id}>{p.nombre}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="prueba-email">Correo para la prueba</Label>
                    <Input
                      id="prueba-email"
                      type="email"
                      placeholder="correo@ejemplo.com"
                      className="w-72"
                      value={pruebaEmail}
                      onChange={(e) => setPruebaEmail(e.target.value)}
                      data-testid="prueba-email-input"
                    />
                  </div>
                  <Button variant="outline" onClick={handleEnviarPrueba} disabled={enviandoPrueba} data-testid="enviar-prueba-btn">
                    {enviandoPrueba ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
                    Enviar Prueba
                  </Button>
                </div>
              </div>

              {/* Reportes mensuales estadísticos por encuesta */}
              <div className="p-4 border rounded-lg space-y-3" data-testid="reportes-mensuales-section">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold flex items-center gap-2">
                      <BarChart3 className="w-4 h-4" />
                      Reportes Mensuales Estadísticos
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      Configure por encuesta a quién se envía el reporte estadístico (tabla por año/trimestre/mes + gráfico NPS), con frecuencia automática (día y hora, hora RD) o manual, y el corte de datos.
                    </p>
                  </div>
                  <Button onClick={openNuevaProg} data-testid="nueva-programacion-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Nueva Programación
                  </Button>
                </div>
                {programaciones.length === 0 ? (
                  <p className="text-sm text-muted-foreground">No hay programaciones configuradas.</p>
                ) : (
                  <div className="border rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Encuesta</TableHead>
                          <TableHead>Destinatarios</TableHead>
                          <TableHead>Frecuencia</TableHead>
                          <TableHead>Corte</TableHead>
                          <TableHead>Último envío</TableHead>
                          <TableHead className="text-center">Activo</TableHead>
                          <TableHead className="text-right">Acciones</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {programaciones.map((prog) => (
                          <TableRow key={prog.id} data-testid={`programacion-row-${prog.id}`}>
                            <TableCell className="font-medium">{prog.plantilla_nombre}</TableCell>
                            <TableCell className="text-xs max-w-[220px]">
                              {(prog.destinatarios || []).map((c, i) => <div key={i}>{c}</div>)}
                            </TableCell>
                            <TableCell className="whitespace-nowrap text-sm">
                              {prog.modo === "automatico" ? `Automático: día ${prog.dia_envio} a las ${prog.hora_envio}` : prog.modo === "cierre" ? `Tras cierre de campaña (siguiente día laborable, ${prog.hora_envio})` : "Manual"}
                            </TableCell>
                            <TableCell className="whitespace-nowrap text-sm">
                              {prog.corte === "hasta_dia" ? "Hasta el día del envío" : "Mes anterior completo"}
                            </TableCell>
                            <TableCell className="whitespace-nowrap text-xs">
                              {prog.ultimo_envio ? new Date(prog.ultimo_envio).toLocaleString() : "-"}
                            </TableCell>
                            <TableCell className="text-center">
                              <Switch
                                checked={prog.activo !== false}
                                onCheckedChange={() => handleToggleProgActivo(prog)}
                                data-testid={`prog-activo-switch-${prog.id}`}
                              />
                            </TableCell>
                            <TableCell className="text-right whitespace-nowrap">
                              <Button
                                variant="ghost" size="sm"
                                onClick={() => handleEnviarAhoraProg(prog)}
                                disabled={enviandoAhoraId === prog.id}
                                title="Enviar ahora a los destinatarios"
                                data-testid={`prog-enviar-ahora-${prog.id}`}
                              >
                                {enviandoAhoraId === prog.id ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                              </Button>
                              <Button
                                variant="ghost" size="sm"
                                onClick={() => { setPruebaMensualProg(prog); setPruebaMensualEmail(""); setShowPruebaMensualDialog(true); }}
                                title="Envío de prueba"
                                data-testid={`prog-prueba-${prog.id}`}
                              >
                                <Mail className="w-4 h-4" />
                              </Button>
                              <Button variant="ghost" size="sm" onClick={() => openEditProg(prog)} title="Editar" data-testid={`prog-editar-${prog.id}`}>
                                <Pencil className="w-4 h-4" />
                              </Button>
                              <Button variant="ghost" size="sm" className="text-destructive" onClick={() => handleEliminarProgramacion(prog)} title="Eliminar" data-testid={`prog-eliminar-${prog.id}`}>
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold flex items-center gap-2">
                    <Clock className="w-4 h-4" />
                    Historial de reportes enviados
                  </h3>
                  {esAdmin && reportesHistorial.length > 0 && (
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={handleBorrarHistorialReportes}
                      data-testid="borrar-historial-reportes-btn"
                    >
                      <Trash2 className="w-4 h-4 mr-2" />
                      Borrar historial
                    </Button>
                  )}
                </div>
                {reportesHistorial.length === 0 ? (
                  <p className="text-sm text-muted-foreground">Aún no se han enviado reportes automáticos.</p>
                ) : (
                  <div className="border rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Fecha</TableHead>
                          <TableHead>Tipo</TableHead>
                          <TableHead>Encuesta / Campaña</TableHead>
                          <TableHead>Detalle</TableHead>
                          <TableHead>Enviado a</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {reportesHistorial.map((r) => (
                          <TableRow key={r.id}>
                            <TableCell className="whitespace-nowrap">{r.created_at ? new Date(r.created_at).toLocaleString() : "-"}</TableCell>
                            <TableCell>
                              {r.tipo === "mensual" ? (
                                <Badge variant="secondary">Mensual</Badge>
                              ) : (
                                <Badge variant="destructive">Alerta NPS</Badge>
                              )}
                            </TableCell>
                            <TableCell>{r.encuesta_nombre || r.campana_nombre || "-"}</TableCell>
                            <TableCell>
                              {r.tipo === "mensual" ? (
                                <span className="text-sm">{r.periodo || "-"}</span>
                              ) : (
                                <span className="text-sm">NPS <Badge variant="destructive">{r.nps_pregunta1}</Badge> · {r.ejecutivo_nombre || "-"}</span>
                              )}
                            </TableCell>
                            <TableCell className="text-xs">
                              {(r.enviados_a || []).map((e, i) => (
                                <div key={i}>{e.rol}: {e.correo}</div>
                              ))}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Dialog Programar Encuesta (desde Destinatarios) */}
      <Dialog open={showProgramarDialog} onOpenChange={setShowProgramarDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              Programar Encuesta
            </DialogTitle>
            <DialogDescription>
              La encuesta se enviará automáticamente a los destinatarios pendientes en la fecha y hora indicadas (hora de Rep. Dominicana).
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="prog-fecha">Fecha de envío</Label>
              <Input
                id="prog-fecha"
                type="date"
                value={progFecha}
                onChange={(e) => setProgFecha(e.target.value)}
                min={new Date().toISOString().split("T")[0]}
                data-testid="programar-fecha-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="prog-hora">Hora de envío</Label>
              <Input
                id="prog-hora"
                type="time"
                value={progHora}
                onChange={(e) => setProgHora(e.target.value)}
                data-testid="programar-hora-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowProgramarDialog(false)} disabled={programando}>
              Cancelar
            </Button>
            <Button onClick={handleProgramarEnvio} disabled={programando} data-testid="confirmar-programar-btn">
              {programando ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Calendar className="w-4 h-4 mr-2" />}
              Programar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Confirmar Borrar Estadísticas */}
      <Dialog open={showConfirmBorrarStats} onOpenChange={(v) => { setShowConfirmBorrarStats(v); if (!v) setCampanaBorrarStats(null); }}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-amber-600">
              <AlertCircle className="w-5 h-5" />
              Borrar Estadísticas
            </DialogTitle>
            <DialogDescription>
              ¿Está seguro de borrar las estadísticas de la encuesta "{campanaBorrarStats?.nombre}"?
              Se eliminarán todas las respuestas recibidas ({campanaBorrarStats?.total_respondidos || 0}). 
              Los destinatarios se mantienen. Esta acción no se puede deshacer.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => { setShowConfirmBorrarStats(false); setCampanaBorrarStats(null); }} disabled={borrandoStats}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={handleBorrarEstadisticas} disabled={borrandoStats} data-testid="confirmar-borrar-stats-btn">
              {borrandoStats ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Trash2 className="w-4 h-4 mr-2" />}
              Sí, Borrar Estadísticas
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Programación de Reporte Mensual */}
      <Dialog open={showProgDialog} onOpenChange={setShowProgDialog}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <BarChart3 className="w-5 h-5" />
              {editingProg ? "Editar Programación" : "Nueva Programación de Reporte Mensual"}
            </DialogTitle>
            <DialogDescription>
              El reporte estadístico NPS de la encuesta seleccionada se enviará a los correos indicados.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Encuesta (plantilla)</Label>
              <Select value={progForm.plantilla_id} onValueChange={(v) => setProgForm({ ...progForm, plantilla_id: v })}>
                <SelectTrigger data-testid="prog-plantilla-select">
                  <SelectValue placeholder="Seleccione una encuesta" />
                </SelectTrigger>
                <SelectContent>
                  {plantillas.map((p) => (
                    <SelectItem key={p.id} value={p.id}>{p.nombre}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="prog-destinatarios">Correos destinatarios adicionales (opcional — el reporte va al ejecutivo encuestado y su supervisor)</Label>
              <Textarea
                id="prog-destinatarios"
                rows={2}
                placeholder="correo1@empresa.com, correo2@empresa.com"
                value={progForm.destinatarios}
                onChange={(e) => setProgForm({ ...progForm, destinatarios: e.target.value })}
                data-testid="prog-destinatarios-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="prog-correos-cc">Correos en copia (CC) — separados por coma (opcional)</Label>
              <Textarea
                id="prog-correos-cc"
                rows={2}
                placeholder="copia1@empresa.com, copia2@empresa.com"
                value={progForm.correos_cc}
                onChange={(e) => setProgForm({ ...progForm, correos_cc: e.target.value })}
                data-testid="prog-correos-cc-input"
              />
            </div>
            <div className="space-y-2">
              <Label>Frecuencia</Label>
              <Select value={progForm.modo} onValueChange={(v) => setProgForm({ ...progForm, modo: v })}>
                <SelectTrigger data-testid="prog-modo-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="automatico">Automático (mensual, día y hora)</SelectItem>
                  <SelectItem value="cierre">Siguiente día laborable tras cierre de campaña</SelectItem>
                  <SelectItem value="manual">Manual (solo con el botón Enviar ahora)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {progForm.modo === "cierre" && (
              <div className="flex gap-4 items-end">
                <div className="space-y-2">
                  <Label htmlFor="prog-hora-cierre">Hora de envío (RD)</Label>
                  <Input
                    id="prog-hora-cierre"
                    type="time" className="w-32"
                    value={progForm.hora_envio}
                    onChange={(e) => setProgForm({ ...progForm, hora_envio: e.target.value })}
                    data-testid="prog-hora-cierre-input"
                  />
                </div>
                <p className="text-xs text-muted-foreground pb-2">Se envía una sola vez por campaña, el siguiente día laborable (L-V) después de cerrarla.</p>
              </div>
            )}
            {progForm.modo === "automatico" && (
              <div className="flex gap-4">
                <div className="space-y-2">
                  <Label htmlFor="prog-dia">Día del mes (1-28)</Label>
                  <Input
                    id="prog-dia"
                    type="number" min="1" max="28" className="w-28"
                    value={progForm.dia_envio}
                    onChange={(e) => setProgForm({ ...progForm, dia_envio: e.target.value })}
                    data-testid="prog-dia-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="prog-hora">Hora (RD)</Label>
                  <Input
                    id="prog-hora"
                    type="time" className="w-32"
                    value={progForm.hora_envio}
                    onChange={(e) => setProgForm({ ...progForm, hora_envio: e.target.value })}
                    data-testid="prog-hora-input"
                  />
                </div>
              </div>
            )}
            <div className="space-y-2">
              <Label>Corte de datos</Label>
              <Select value={progForm.corte} onValueChange={(v) => setProgForm({ ...progForm, corte: v })}>
                <SelectTrigger data-testid="prog-corte-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="mes_anterior">Mes anterior completo</SelectItem>
                  <SelectItem value="hasta_dia">Hasta el día del envío</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="flex items-center gap-3">
              <Switch
                checked={progForm.activo}
                onCheckedChange={(v) => setProgForm({ ...progForm, activo: v })}
                data-testid="prog-form-activo-switch"
              />
              <Label>Programación activa</Label>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowProgDialog(false)} disabled={savingProg}>
              Cancelar
            </Button>
            <Button onClick={handleGuardarProgramacion} disabled={savingProg} data-testid="guardar-programacion-btn">
              {savingProg ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle className="w-4 h-4 mr-2" />}
              Guardar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Prueba de Reporte Mensual */}
      <Dialog open={showPruebaMensualDialog} onOpenChange={setShowPruebaMensualDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Mail className="w-5 h-5" />
              Envío de Prueba — Reporte Mensual
            </DialogTitle>
            <DialogDescription>
              Se enviará el reporte de "{pruebaMensualProg?.plantilla_nombre}" con datos reales al correo indicado, marcado como PRUEBA.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            <Label htmlFor="prueba-mensual-email">Correo para la prueba</Label>
            <Input
              id="prueba-mensual-email"
              type="email"
              placeholder="correo@ejemplo.com"
              value={pruebaMensualEmail}
              onChange={(e) => setPruebaMensualEmail(e.target.value)}
              data-testid="prueba-mensual-email-input"
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPruebaMensualDialog(false)} disabled={enviandoPruebaMensual}>
              Cancelar
            </Button>
            <Button onClick={handleEnviarPruebaMensual} disabled={enviandoPruebaMensual} data-testid="confirmar-prueba-mensual-btn">
              {enviandoPruebaMensual ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
              Enviar Prueba
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de confirmación para cerrar masivo */}
      <Dialog open={showConfirmCerrar} onOpenChange={setShowConfirmCerrar}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirmar Cierre de Encuestas</DialogTitle>
            <DialogDescription>
              ¿Está seguro de cerrar {selectedCampanas.length} encuesta(s)? 
              Las encuestas cerradas no aceptarán más respuestas.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowConfirmCerrar(false)}>
              Cancelar
            </Button>
            <Button onClick={handleCerrarMasivo} disabled={processingBulk}>
              {processingBulk ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : null}
              Cerrar Encuestas
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de confirmación para eliminar masivo */}
      <Dialog open={showConfirmEliminar} onOpenChange={setShowConfirmEliminar}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-destructive">Confirmar Eliminación</DialogTitle>
            <DialogDescription>
              ¿Está seguro de eliminar {selectedCampanas.length} encuesta(s)? 
              Esta acción eliminará todos los destinatarios y respuestas asociadas. 
              <strong className="block mt-2 text-destructive">Esta acción no se puede deshacer.</strong>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowConfirmEliminar(false)}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={handleEliminarMasivo} disabled={processingBulk}>
              {processingBulk ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : null}
              Eliminar Encuestas
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog para crear/editar campaña */}
      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {editingCampana ? "Editar Campaña" : "Nueva Campaña de Encuestas"}
            </DialogTitle>
            <DialogDescription>
              Configure los parámetros de la campaña
            </DialogDescription>
          </DialogHeader>

          <Tabs defaultValue="general" className="w-full">
            <TabsList className="grid w-full grid-cols-4 max-w-xl">
              <TabsTrigger value="general">General</TabsTrigger>
              <TabsTrigger value="importar">Importar Excel</TabsTrigger>
              <TabsTrigger value="campos">Campos</TabsTrigger>
              <TabsTrigger value="recordatorios">Recordatorios</TabsTrigger>
            </TabsList>

            <TabsContent value="general" className="space-y-4 mt-4">
              <div className="space-y-2">
                <Label htmlFor="nombre">Nombre de la Campaña *</Label>
                <Input
                  id="nombre"
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  placeholder="Ej: Encuesta Satisfacción Enero 2026"
                  data-testid="campana-nombre-input"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="encuesta">Plantilla de Encuesta *</Label>
                <Select 
                  value={formData.encuesta_id} 
                  onValueChange={handlePlantillaChange}
                >
                  <SelectTrigger data-testid="campana-encuesta-select">
                    <SelectValue placeholder="Seleccione una encuesta" />
                  </SelectTrigger>
                  <SelectContent>
                    {plantillas.map((p) => (
                      <SelectItem key={p.id} value={p.id}>{p.nombre}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="descripcion">Descripción</Label>
                <Textarea
                  id="descripcion"
                  value={formData.descripcion}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  placeholder="Descripción interna de la campaña"
                  rows={2}
                />
              </div>

              {/* Campos adicionales de la campaña */}
              <div className="space-y-4 pt-4 border-t">
                <Label className="text-base font-semibold flex items-center gap-2">
                  <ClipboardList className="w-4 h-4" />
                  Configuración de la Encuesta
                </Label>

                {/* Campo de fecha según el tipo de encuesta de la plantilla seleccionada */}
                {getCampoFechaPlantilla(formData.encuesta_id) === "renovacion" && (
                  <div className="space-y-2">
                    <Label>Mes de renovación a encuestar</Label>
                    <div className="grid grid-cols-2 gap-3">
                      <Select value={formData.renovacion_mes || ""} onValueChange={(v) => setFormData({ ...formData, renovacion_mes: v })}>
                        <SelectTrigger data-testid="campana-renovacion-mes-select"><SelectValue placeholder="Mes" /></SelectTrigger>
                        <SelectContent>
                          {MESES.map((m) => (<SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>))}
                        </SelectContent>
                      </Select>
                      <Select value={formData.renovacion_anio || ""} onValueChange={(v) => setFormData({ ...formData, renovacion_anio: v })}>
                        <SelectTrigger data-testid="campana-renovacion-anio-select"><SelectValue placeholder="Año" /></SelectTrigger>
                        <SelectContent>
                          {ANIOS.map((y) => (<SelectItem key={y} value={String(y)}>{y}</SelectItem>))}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                )}
                {getCampoFechaPlantilla(formData.encuesta_id) === "reclamo" && (
                  <div className="space-y-2">
                    <Label>Mes del reclamo encuestado</Label>
                    <div className="grid grid-cols-2 gap-3">
                      <Select value={formData.reclamo_mes || ""} onValueChange={(v) => setFormData({ ...formData, reclamo_mes: v })}>
                        <SelectTrigger data-testid="campana-reclamo-mes-select"><SelectValue placeholder="Mes" /></SelectTrigger>
                        <SelectContent>
                          {MESES.map((m) => (<SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>))}
                        </SelectContent>
                      </Select>
                      <Select value={formData.reclamo_anio || ""} onValueChange={(v) => setFormData({ ...formData, reclamo_anio: v })}>
                        <SelectTrigger data-testid="campana-reclamo-anio-select"><SelectValue placeholder="Año" /></SelectTrigger>
                        <SelectContent>
                          {ANIOS.map((y) => (<SelectItem key={y} value={String(y)}>{y}</SelectItem>))}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                )}

                {/* Ejecutivo a encuestar (filtrado por departamento de la plantilla) */}
                <div className="space-y-2">
                  <Label>Ejecutivo a encuestar *</Label>
                  <Select
                    value={formData.ejecutivo_encuestar_id || ""}
                    onValueChange={(v) => {
                      const ej = ejecutivosDept.find((e) => e.id === v);
                      setFormData({ ...formData, ejecutivo_encuestar_id: v, ejecutivo_encuestar_nombre: ej?.nombre || "" });
                    }}
                    disabled={!formData.encuesta_id || loadingEjecutivos}
                  >
                    <SelectTrigger data-testid="campana-ejecutivo-select">
                      <SelectValue placeholder={!formData.encuesta_id ? "Primero seleccione una plantilla" : (loadingEjecutivos ? "Cargando ejecutivos..." : "Seleccione un ejecutivo")} />
                    </SelectTrigger>
                    <SelectContent>
                      {ejecutivosDept.map((e) => (
                        <SelectItem key={e.id} value={e.id}>{e.nombre}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {formData.encuesta_id && !loadingEjecutivos && ejecutivosDept.length === 0 && (
                    <p className="text-xs text-amber-600">No hay ejecutivos asociados al departamento de esta plantilla. Verifique que la plantilla tenga un departamento asignado.</p>
                  )}
                </div>

                {/* Muestras mínimas */}
                <div className="space-y-2">
                  <Label htmlFor="muestras_minimas">Muestras mínimas *</Label>
                  <Input
                    id="muestras_minimas"
                    type="number"
                    min={1}
                    value={formData.muestras_minimas}
                    onChange={(e) => setFormData({ ...formData, muestras_minimas: e.target.value })}
                    placeholder="Ej: 30"
                    data-testid="campana-muestras-minimas-input"
                  />
                  <p className="text-xs text-muted-foreground">La encuesta se cerrará automáticamente cuando la cantidad de destinatarios que respondan alcance este número.</p>
                </div>
              </div>

              {/* Configuración de Envío */}
              <div className="space-y-3 pt-4 border-t">
                <Label className="text-base font-semibold flex items-center gap-2">
                  <Send className="w-4 h-4" />
                  Configuración de Envío
                </Label>
                
                <div className="grid grid-cols-2 gap-4">
                  <div 
                    className={`p-4 border rounded-lg cursor-pointer transition-all ${
                      formData.tipo_envio === "inmediato" 
                        ? "border-primary bg-primary/5 ring-2 ring-primary/20" 
                        : "hover:border-muted-foreground/50"
                    }`}
                    onClick={() => setFormData({ ...formData, tipo_envio: "inmediato" })}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <Play className="w-5 h-5 text-green-600" />
                      <span className="font-medium">Envío Inmediato</span>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      Las encuestas se enviarán manualmente cuando haga clic en "Enviar"
                    </p>
                  </div>
                  
                  <div 
                    className={`p-4 border rounded-lg cursor-pointer transition-all ${
                      formData.tipo_envio === "programado" 
                        ? "border-primary bg-primary/5 ring-2 ring-primary/20" 
                        : "hover:border-muted-foreground/50"
                    }`}
                    onClick={() => setFormData({ ...formData, tipo_envio: "programado" })}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <Calendar className="w-5 h-5 text-blue-600" />
                      <span className="font-medium">Envío Programado</span>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      Las encuestas se enviarán automáticamente en la fecha y hora indicada
                    </p>
                  </div>
                </div>

                {formData.tipo_envio === "programado" && (
                  <div className="grid grid-cols-2 gap-4 pl-4 border-l-2 border-blue-300 mt-3">
                    <div className="space-y-2">
                      <Label>Fecha de Envío</Label>
                      <Input
                        type="date"
                        value={formData.fecha_envio_programado}
                        onChange={(e) => setFormData({ ...formData, fecha_envio_programado: e.target.value })}
                        min={new Date().toISOString().split('T')[0]}
                        data-testid="fecha-envio-input"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label>Hora de Envío</Label>
                      <Input
                        type="time"
                        value={formData.hora_envio_programado}
                        onChange={(e) => setFormData({ ...formData, hora_envio_programado: e.target.value })}
                        data-testid="hora-envio-input"
                      />
                    </div>
                  </div>
                )}
              </div>
            </TabsContent>

            <TabsContent value="importar" className="space-y-4 mt-4">
              {/* Indicador de pasos */}
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${importStep >= 1 ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
                  <span className="text-xs font-medium">1. Subir</span>
                </div>
                <ChevronRight className="w-4 h-4 text-muted-foreground" />
                <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${importStep >= 2 ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
                  <span className="text-xs font-medium">2. Mapear</span>
                </div>
                <ChevronRight className="w-4 h-4 text-muted-foreground" />
                <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${importStep >= 3 ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
                  <span className="text-xs font-medium">3. Confirmar</span>
                </div>
              </div>

              {/* PASO 1: Subir archivo */}
              {importStep === 1 && (
                <Card>
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base flex items-center gap-2">
                      <Upload className="w-5 h-5" />
                      Importar Destinatarios con IA
                    </CardTitle>
                    <CardDescription>
                      La IA analizará su Excel y sugerirá el mapeo de columnas automáticamente
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="relative">
                      <input
                        type="file"
                        id="excel-file-input"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleImportExcelIA}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        disabled={uploadingFile || processingIA}
                      />
                      <Button variant="outline" className="w-full h-24 border-dashed" disabled={uploadingFile || processingIA}>
                        {processingIA ? (
                          <div className="flex flex-col items-center gap-2">
                            <RefreshCw className="w-6 h-6 animate-spin" />
                            <span>Analizando con IA...</span>
                          </div>
                        ) : (
                          <div className="flex flex-col items-center gap-2">
                            <FileSpreadsheet className="w-8 h-8" />
                            <span>Arrastra un archivo Excel o haz clic para seleccionar</span>
                          </div>
                        )}
                      </Button>
                    </div>

                    {importedDestinatarios.length > 0 && (
                      <div className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg">
                        <div className="flex items-center gap-2">
                          <CheckCircle className="w-5 h-5 text-green-600" />
                          <span className="font-medium text-green-800">{importedDestinatarios.length} destinatarios listos</span>
                        </div>
                        <Button variant="ghost" size="sm" onClick={clearImport}>
                          <Trash2 className="w-4 h-4 mr-1" />
                          Limpiar
                        </Button>
                      </div>
                    )}

                    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>Proceso inteligente:</strong> Al subir el archivo, la IA analizará las columnas y sugerirá cómo mapearlas a los campos del sistema. Podrá revisar y modificar el mapeo antes de confirmar.
                      </p>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* PASO 2: Mapear columnas */}
              {importStep === 2 && mapeoData && (
                <Card>
                  <CardHeader className="pb-3">
                    <div className="flex items-center justify-between">
                      <div>
                        <CardTitle className="text-base flex items-center gap-2">
                          <Settings className="w-5 h-5" />
                          Mapeo de Columnas
                        </CardTitle>
                        <CardDescription>
                          Revise y ajuste el mapeo sugerido por la IA. {mapeoData.total_filas} registros encontrados.
                        </CardDescription>
                      </div>
                      <Button variant="ghost" size="sm" onClick={() => setImportStep(1)}>
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Volver
                      </Button>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    {mapeoData.ia_usada && (
                      <div className="p-2 bg-purple-50 border border-purple-200 rounded text-sm text-purple-800">
                        Sugerencias de IA con {Math.round((mapeoData.confianza_ia || 0) * 100)}% de confianza
                      </div>
                    )}

                    {/* Tabla de mapeo */}
                    <div className="border rounded-lg overflow-hidden">
                      <div className="bg-muted px-3 py-2 text-sm font-medium grid grid-cols-2 gap-4">
                        <span>Columna del Excel</span>
                        <span>Campo del Sistema</span>
                      </div>
                      <div className="divide-y max-h-[300px] overflow-y-auto">
                        {mapeoData.columnas_excel?.map((col) => (
                          <div key={col} className="px-3 py-2 grid grid-cols-2 gap-4 items-center hover:bg-muted/50">
                            <div>
                              <span className="font-medium">{col}</span>
                              {mapeoData.sample_data?.[0]?.[col] && (
                                <span className="block text-xs text-muted-foreground truncate">
                                  Ej: {String(mapeoData.sample_data[0][col]).substring(0, 30)}
                                </span>
                              )}
                            </div>
                            <Select
                              value={mapeoActual[col] || "none"}
                              onValueChange={(v) => setMapeoActual({ ...mapeoActual, [col]: v === "none" ? null : v })}
                            >
                              <SelectTrigger className="w-full">
                                <SelectValue placeholder="No mapear" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="none">-- No mapear --</SelectItem>
                                {mapeoData.campos_sistema?.map((campo) => (
                                  <SelectItem key={campo.id} value={campo.id}>
                                    {campo.nombre}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Vista previa de datos originales */}
                    <div className="border rounded-lg overflow-hidden">
                      <div className="bg-muted px-3 py-2 text-sm font-medium">
                        Vista previa del Excel (primeros 3 registros)
                      </div>
                      <div className="overflow-x-auto max-w-full">
                        <table className="w-full text-sm table-auto">
                          <thead className="bg-muted/50">
                            <tr>
                              {mapeoData.columnas_excel?.map((col) => (
                                <th key={col} className="px-2 py-2 text-left font-medium text-xs truncate max-w-[150px]" title={col}>{col}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {mapeoData.sample_data?.map((row, idx) => (
                              <tr key={idx} className="border-t">
                                {mapeoData.columnas_excel?.map((col) => (
                                  <td key={col} className="px-2 py-2 text-xs truncate max-w-[150px]" title={String(row[col] || "-")}>
                                    {String(row[col] || "-").substring(0, 20)}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="flex justify-end gap-2">
                      <Button variant="outline" onClick={() => setImportStep(1)}>
                        Cancelar
                      </Button>
                      <Button onClick={handleAplicarMapeo} disabled={processingIA}>
                        {processingIA ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : null}
                        Ver Vista Previa
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* PASO 3: Vista previa y confirmación */}
              {importStep === 3 && mappedPreview && (
                <Card>
                  <CardHeader className="pb-3">
                    <div className="flex items-center justify-between">
                      <div>
                        <CardTitle className="text-base flex items-center gap-2">
                          <Eye className="w-5 h-5" />
                          Vista Previa de Datos Mapeados
                        </CardTitle>
                        <CardDescription>
                          Revise cómo quedarán los datos después del mapeo
                        </CardDescription>
                      </div>
                      <Button variant="ghost" size="sm" onClick={() => setImportStep(2)}>
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Modificar Mapeo
                      </Button>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    {/* Resumen */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                        <div className="text-2xl font-bold text-green-700">{mappedPreview.total_validos}</div>
                        <div className="text-sm text-green-600">Registros válidos</div>
                      </div>
                      <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="text-2xl font-bold text-amber-700">{mappedPreview.total_errores}</div>
                        <div className="text-sm text-amber-600">Con errores</div>
                      </div>
                    </div>

                    {/* Errores */}
                    {mappedPreview.errores?.length > 0 && (
                      <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="flex items-center gap-2 text-amber-700 mb-2">
                          <AlertCircle className="w-4 h-4" />
                          <span className="font-medium">Registros con errores (no se importarán)</span>
                        </div>
                        <ul className="text-sm text-amber-600 list-disc list-inside">
                          {mappedPreview.errores.map((err, idx) => (
                            <li key={idx}>{err}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Tabla de vista previa */}
                    <div className="border rounded-lg overflow-hidden">
                      <div className="bg-muted px-3 py-2 text-sm font-medium">
                        Datos mapeados (primeros 20 registros)
                      </div>
                      <div className="overflow-x-auto max-h-[250px]">
                        <table className="w-full text-xs table-auto min-w-full">
                          <thead className="bg-muted/50 sticky top-0">
                            <tr>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Cliente</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Correo</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Teléfono</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Ejecutivo</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Supervisor</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Aseguradora</th>
                              <th className="px-2 py-2 text-left whitespace-nowrap">Póliza</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mappedPreview.destinatarios?.map((dest, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="px-2 py-1.5 truncate max-w-[120px]" title={dest.nombre_cliente}>{dest.nombre_cliente || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[150px]" title={dest.correo}>{dest.correo || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[100px]" title={dest.telefono}>{dest.telefono || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[100px]" title={dest.ejecutivo}>{dest.ejecutivo || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[100px]" title={dest.supervisor}>{dest.supervisor || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[100px]" title={dest.aseguradora}>{dest.aseguradora || "-"}</td>
                                <td className="px-2 py-1.5 truncate max-w-[100px]" title={dest.poliza}>{dest.poliza || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="flex justify-end gap-2">
                      <Button variant="outline" onClick={clearImport}>
                        Cancelar
                      </Button>
                      <Button onClick={handleConfirmarImportacion}>
                        <CheckCircle className="w-4 h-4 mr-2" />
                        Confirmar Importación ({mappedPreview.total_validos} registros)
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}
            </TabsContent>

            <TabsContent value="campos" className="space-y-4 mt-4">
              <p className="text-sm text-muted-foreground">
                Seleccione los campos que serán obligatorios al importar el Excel de destinatarios
              </p>
              <div className="space-y-2">
                {(camposDisponibles.length > 0 ? camposDisponibles : [
                  { id: "nombre_cliente", nombre: "Nombre del Cliente" },
                  { id: "correo", nombre: "Correo Electrónico" },
                  { id: "ejecutivo", nombre: "Ejecutivo" },
                  { id: "telefono", nombre: "Teléfono" },
                  { id: "contacto", nombre: "Contacto" },
                  { id: "padrino", nombre: "Padrino" },
                  { id: "email_padrino", nombre: "Email Padrino" },
                  { id: "aseguradora", nombre: "Aseguradora" },
                  { id: "poliza", nombre: "Número de Póliza" },
                  { id: "numero_reclamo", nombre: "Número de Reclamo" },
                  { id: "clase_cliente", nombre: "Clase de Cliente" }
                ]).map((campo) => (
                  <div key={campo.id} className="flex items-center space-x-2 p-2 rounded hover:bg-muted">
                    <Checkbox
                      id={campo.id}
                      checked={formData.campos_requeridos.includes(campo.id)}
                      onCheckedChange={() => toggleCampoRequerido(campo.id)}
                      disabled={campo.id === "correo"} // Correo siempre requerido
                    />
                    <Label htmlFor={campo.id} className="flex-1 cursor-pointer">
                      {campo.nombre}
                      {campo.id === "correo" && (
                        <span className="text-xs text-muted-foreground ml-2">(Siempre requerido)</span>
                      )}
                    </Label>
                  </div>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="recordatorios" className="space-y-4 mt-4">
              <div className="flex items-center justify-between p-4 border rounded-lg bg-muted/50">
                <div className="flex items-center gap-3">
                  <Bell className="w-6 h-6 text-amber-600" />
                  <div>
                    <Label htmlFor="recordatorios_activo" className="text-base font-medium">Enviar Recordatorios Automáticos</Label>
                    <p className="text-sm text-muted-foreground">
                      Reenviar automáticamente la encuesta a quienes no respondan
                    </p>
                  </div>
                </div>
                <Switch
                  id="recordatorios_activo"
                  checked={formData.recordatorios.activo}
                  onCheckedChange={(v) => setFormData({
                    ...formData,
                    recordatorios: { ...formData.recordatorios, activo: v }
                  })}
                  data-testid="recordatorios-activo-switch"
                />
              </div>

              {formData.recordatorios.activo && (
                <div className="space-y-4 p-4 border rounded-lg bg-amber-50/50">
                  <div className="flex items-center gap-2 text-amber-700 mb-2">
                    <Clock className="w-4 h-4" />
                    <span className="font-medium">Configuración de Recordatorios</span>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-4">
                    <div className="space-y-2">
                      <Label>Primer Recordatorio</Label>
                      <div className="flex items-center gap-2">
                        <Input
                          type="number"
                          value={formData.recordatorios.dias_primer_recordatorio}
                          onChange={(e) => setFormData({
                            ...formData,
                            recordatorios: { ...formData.recordatorios, dias_primer_recordatorio: parseInt(e.target.value) || 3 }
                          })}
                          min={1}
                          max={30}
                          className="w-20"
                          data-testid="primer-recordatorio-input"
                        />
                        <span className="text-sm text-muted-foreground">días después</span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Label>Segundo Recordatorio</Label>
                      <div className="flex items-center gap-2">
                        <Input
                          type="number"
                          value={formData.recordatorios.dias_segundo_recordatorio}
                          onChange={(e) => setFormData({
                            ...formData,
                            recordatorios: { ...formData.recordatorios, dias_segundo_recordatorio: parseInt(e.target.value) || 7 }
                          })}
                          min={1}
                          max={30}
                          className="w-20"
                          data-testid="segundo-recordatorio-input"
                        />
                        <span className="text-sm text-muted-foreground">días después</span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Label>Tercer Recordatorio</Label>
                      <div className="flex items-center gap-2">
                        <Input
                          type="number"
                          value={formData.recordatorios.dias_tercer_recordatorio || 10}
                          onChange={(e) => setFormData({
                            ...formData,
                            recordatorios: { ...formData.recordatorios, dias_tercer_recordatorio: parseInt(e.target.value) || 10 }
                          })}
                          min={1}
                          max={30}
                          className="w-20"
                          data-testid="tercer-recordatorio-input"
                        />
                        <span className="text-sm text-muted-foreground">días después</span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Label>Máximo de Recordatorios</Label>
                      <Select 
                        value={String(formData.recordatorios.max_recordatorios)} 
                        onValueChange={(v) => setFormData({
                          ...formData,
                          recordatorios: { ...formData.recordatorios, max_recordatorios: parseInt(v) }
                        })}
                      >
                        <SelectTrigger data-testid="max-recordatorios-select">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="1">1 recordatorio</SelectItem>
                          <SelectItem value="2">2 recordatorios</SelectItem>
                          <SelectItem value="3">3 recordatorios</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                  
                  <div className="space-y-2 pt-3 border-t">
                    <Label>Hora de Envío de Recordatorios</Label>
                    <div className="flex items-center gap-2">
                      <Input
                        type="time"
                        value={formData.recordatorios.hora_envio}
                        onChange={(e) => setFormData({
                          ...formData,
                          recordatorios: { ...formData.recordatorios, hora_envio: e.target.value }
                        })}
                        className="w-32"
                        data-testid="hora-recordatorio-input"
                      />
                      <span className="text-sm text-muted-foreground">
                        Los recordatorios se enviarán a esta hora
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-3 bg-white rounded border text-sm">
                    <p className="font-medium text-slate-700 mb-1">Resumen de Recordatorios:</p>
                    <ul className="text-muted-foreground space-y-1">
                      <li>• 1er recordatorio: {formData.recordatorios.dias_primer_recordatorio} días después del envío inicial</li>
                      {formData.recordatorios.max_recordatorios >= 2 && (
                        <li>• 2do recordatorio: {formData.recordatorios.dias_segundo_recordatorio} días después del envío inicial</li>
                      )}
                      {formData.recordatorios.max_recordatorios >= 3 && (
                        <li>• 3er recordatorio: {formData.recordatorios.dias_tercer_recordatorio || 10} días después del envío inicial</li>
                      )}
                      <li>• Hora de envío: {formData.recordatorios.hora_envio}</li>
                    </ul>
                  </div>
                </div>
              )}
            </TabsContent>
          </Tabs>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDialog(false)}>Cancelar</Button>
            <Button onClick={handleSubmit} data-testid="guardar-campana-btn">
              {editingCampana ? "Actualizar" : "Crear"} Campaña
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Destinatarios */}
      <Dialog open={showDestinatariosDialog} onOpenChange={setShowDestinatariosDialog}>
        <DialogContent className="max-w-[95vw] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              Destinatarios - {selectedCampana?.nombre}
            </DialogTitle>
            <DialogDescription>
              Importe, gestione y envíe encuestas a sus clientes
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            {/* Acciones */}
            <div className="flex flex-wrap gap-2">
              {!soloLectura && (
              <>
              <div className="relative">
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileUpload}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  disabled={uploadingFile}
                />
                <Button variant="outline" disabled={uploadingFile}>
                  {uploadingFile ? (
                    <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Upload className="w-4 h-4 mr-2" />
                  )}
                  Importar Excel
                </Button>
              </div>

              <Button
                variant="outline"
                onClick={() => { setAddDestForm(DEST_FORM_VACIO); setShowAddDest(true); }}
                data-testid="agregar-destinatario-btn"
              >
                <Plus className="w-4 h-4 mr-2" />
                Agregar Destinatario
              </Button>

              <Button 
                onClick={handleEnviarEncuestas} 
                disabled={sendingEmails || destinatarios.filter(d => !d.enviado).length === 0}
                data-testid="enviar-encuestas-btn"
              >
                {sendingEmails ? (
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <Send className="w-4 h-4 mr-2" />
                )}
                Enviar Encuestas
              </Button>

              <Button 
                variant="outline" 
                onClick={() => {
                  setProgFecha(selectedCampana?.fecha_envio_programado || "");
                  setProgHora(selectedCampana?.hora_envio_programado || "09:00");
                  setShowProgramarDialog(true);
                }}
                data-testid="programar-encuesta-btn"
              >
                <Calendar className="w-4 h-4 mr-2" />
                Programar Encuesta
              </Button>

              <Button variant="outline" onClick={handleEnviarRecordatorios}>
                <Bell className="w-4 h-4 mr-2" />
                Enviar Recordatorios
              </Button>

              <Button variant="destructive" onClick={handleEliminarTodos} disabled={destinatarios.length === 0}>
                <Trash2 className="w-4 h-4 mr-2" />
                Eliminar Todos
              </Button>
              </>
              )}
            </div>

            {/* Filtros */}
            <div className="flex flex-wrap items-center gap-4">
              <Label>Filtrar:</Label>
              <Select value={filterEstado} onValueChange={(v) => {
                setFilterEstado(v);
                fetchDestinatarios(selectedCampana.id, v, 1, searchDest);
              }}>
                <SelectTrigger className="w-[180px]">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="todos">Todos</SelectItem>
                  <SelectItem value="pendiente">Pendientes de Envío</SelectItem>
                  <SelectItem value="enviado">Enviados (Sin Respuesta)</SelectItem>
                  <SelectItem value="respondido">Respondidos</SelectItem>
                </SelectContent>
              </Select>
              <Input
                value={searchDest}
                onChange={(e) => {
                  const v = e.target.value;
                  setSearchDest(v);
                  if (searchDestTimer.current) clearTimeout(searchDestTimer.current);
                  searchDestTimer.current = setTimeout(() => {
                    fetchDestinatarios(selectedCampana.id, filterEstado, 1, v);
                  }, 400);
                }}
                placeholder="Buscar por nombre o correo..."
                className="w-[280px]"
                data-testid="destinatarios-buscar-input"
              />
              <span className="text-sm text-muted-foreground">
                {destinatarioTotal} destinatarios
              </span>
            </div>

            {/* Tabla */}
            {destinatariosLoading ? (
              <div className="flex justify-center py-8">
                <RefreshCw className="w-6 h-6 animate-spin" />
              </div>
            ) : destinatarios.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                <FileSpreadsheet className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p>No hay destinatarios</p>
                <p className="text-sm">Importe un archivo Excel para comenzar</p>
              </div>
            ) : (
              <div className="border rounded-lg overflow-hidden">
                <ScrollArea className="w-full">
                  <div className="w-full overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead className="sticky left-0 bg-background z-10 whitespace-nowrap">Cliente</TableHead>
                          <TableHead className="whitespace-nowrap">Correo</TableHead>
                          <TableHead className="whitespace-nowrap">Teléfono</TableHead>
                          <TableHead className="whitespace-nowrap">Contacto</TableHead>
                          <TableHead className="whitespace-nowrap">Póliza</TableHead>
                          <TableHead className="whitespace-nowrap">Aseguradora</TableHead>
                          <TableHead className="whitespace-nowrap">Padrino</TableHead>
                          <TableHead className="whitespace-nowrap">Email Padrino</TableHead>
                          <TableHead className="whitespace-nowrap">No. Reclamo</TableHead>
                          <TableHead className="whitespace-nowrap">Ejecutivo</TableHead>
                          <TableHead className="whitespace-nowrap">Clase de Cliente</TableHead>
                          <TableHead className="whitespace-nowrap">Estado</TableHead>
                          <TableHead className="whitespace-nowrap text-center">Link</TableHead>
                          <TableHead className="w-[50px]"></TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {destinatarios.map((dest) => (
                          <TableRow key={dest.id}>
                            <TableCell className="font-medium sticky left-0 bg-background whitespace-nowrap">{dest.nombre_cliente || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.correo}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.telefono || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.contacto || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.poliza || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.aseguradora || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.padrino || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.email_padrino || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.numero_reclamo || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">{dest.ejecutivo || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap" data-testid={`dest-clase-${dest.id}`}>{dest.clase_cliente || "-"}</TableCell>
                            <TableCell className="whitespace-nowrap">
                              {dest.respondido ? (
                                <Badge variant="success" className="gap-1">
                                  <CheckCircle className="w-3 h-3" />
                                  Respondido
                                </Badge>
                              ) : dest.enviado ? (
                                <Badge variant="secondary" className="gap-1">
                                  <Clock className="w-3 h-3" />
                                  Enviado
                                </Badge>
                              ) : (
                                <Badge variant="outline" className="gap-1">
                                  <AlertCircle className="w-3 h-3" />
                                  Pendiente
                                </Badge>
                              )}
                            </TableCell>
                            <TableCell className="text-center">
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => {
                                  const baseUrl = window.location.origin;
                                  const link = `${baseUrl}/encuesta/${dest.token}`;
                                  navigator.clipboard.writeText(link);
                                  toast.success("Link copiado al portapapeles");
                                }}
                                title="Copiar link de encuesta"
                              >
                                <Copy className="w-4 h-4" />
                              </Button>
                            </TableCell>
                            <TableCell>
                              {!soloLectura && (
                              <div className="flex">
                                {!dest.enviado && (
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    disabled={sendingOneId === dest.id}
                                    onClick={() => handleEnviarAUno(dest)}
                                    title="Enviar encuesta a este destinatario"
                                    data-testid={`enviar-uno-${dest.id}`}
                                  >
                                    {sendingOneId === dest.id ? (
                                      <RefreshCw className="w-4 h-4 animate-spin" />
                                    ) : (
                                      <Send className="w-4 h-4" />
                                    )}
                                  </Button>
                                )}
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => {
                                    setEditingDest(dest);
                                    setEditDestForm({
                                      correo: dest.correo || "",
                                      padrino: dest.padrino || "",
                                      email_padrino: dest.email_padrino || ""
                                    });
                                  }}
                                  title="Editar destinatario"
                                  data-testid={`editar-destinatario-${dest.id}`}
                                >
                                  <Pencil className="w-4 h-4" />
                                </Button>
                                <Button 
                                  variant="ghost" 
                                  size="icon"
                                  onClick={() => handleEliminarDestinatario(dest.id)}
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                  <ScrollBar orientation="horizontal" />
                </ScrollArea>
              </div>
            )}

            {destinatarioTotal > 50 && (
              <div className="flex items-center justify-between pt-2" data-testid="destinatarios-paginacion">
                <span className="text-sm text-muted-foreground">
                  Página {destinatarioPage} de {Math.ceil(destinatarioTotal / 50)}
                </span>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    disabled={destinatarioPage <= 1 || destinatariosLoading}
                    onClick={() => fetchDestinatarios(selectedCampana.id, filterEstado, destinatarioPage - 1, searchDest)}
                    data-testid="destinatarios-pagina-anterior"
                  >
                    Anterior
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    disabled={destinatarioPage >= Math.ceil(destinatarioTotal / 50) || destinatariosLoading}
                    onClick={() => fetchDestinatarios(selectedCampana.id, filterEstado, destinatarioPage + 1, searchDest)}
                    data-testid="destinatarios-pagina-siguiente"
                  >
                    Siguiente
                  </Button>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Editar Destinatario */}
      <Dialog open={showAddDest} onOpenChange={(open) => !open && setShowAddDest(false)}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="agregar-destinatario-dialog">
          <DialogHeader>
            <DialogTitle>Agregar Destinatario</DialogTitle>
            <DialogDescription>Añada un destinatario individual sin usar Excel</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Nombre del Cliente *</Label>
              <Input value={addDestForm.nombre_cliente} onChange={(e) => setAddDestForm((p) => ({ ...p, nombre_cliente: e.target.value }))} placeholder="Nombre completo" data-testid="add-dest-nombre" />
            </div>
            <div className="space-y-2">
              <Label>Correo *</Label>
              <Input value={addDestForm.correo} onChange={(e) => setAddDestForm((p) => ({ ...p, correo: e.target.value }))} placeholder="correo@ejemplo.com" data-testid="add-dest-correo" />
            </div>
            <div className="space-y-2">
              <Label>Teléfono</Label>
              <Input value={addDestForm.telefono} onChange={(e) => setAddDestForm((p) => ({ ...p, telefono: e.target.value }))} placeholder="809-000-0000" data-testid="add-dest-telefono" />
            </div>
            <div className="space-y-2">
              <Label>Contacto</Label>
              <Input value={addDestForm.contacto} onChange={(e) => setAddDestForm((p) => ({ ...p, contacto: e.target.value }))} data-testid="add-dest-contacto" />
            </div>
            <div className="space-y-2">
              <Label>Póliza</Label>
              <Input value={addDestForm.poliza} onChange={(e) => setAddDestForm((p) => ({ ...p, poliza: e.target.value }))} data-testid="add-dest-poliza" />
            </div>
            <div className="space-y-2">
              <Label>Aseguradora</Label>
              <Input value={addDestForm.aseguradora} onChange={(e) => setAddDestForm((p) => ({ ...p, aseguradora: e.target.value }))} data-testid="add-dest-aseguradora" />
            </div>
            <div className="space-y-2">
              <Label>Padrino</Label>
              <Input value={addDestForm.padrino} onChange={(e) => setAddDestForm((p) => ({ ...p, padrino: e.target.value }))} data-testid="add-dest-padrino" />
            </div>
            <div className="space-y-2">
              <Label>Email Padrino</Label>
              <Input value={addDestForm.email_padrino} onChange={(e) => setAddDestForm((p) => ({ ...p, email_padrino: e.target.value }))} placeholder="padrino@ejemplo.com" data-testid="add-dest-email-padrino" />
            </div>
            <div className="space-y-2">
              <Label>No. Reclamo</Label>
              <Input value={addDestForm.numero_reclamo} onChange={(e) => setAddDestForm((p) => ({ ...p, numero_reclamo: e.target.value }))} data-testid="add-dest-reclamo" />
            </div>
            <div className="space-y-2">
              <Label>Ejecutivo</Label>
              <Input value={addDestForm.ejecutivo} onChange={(e) => setAddDestForm((p) => ({ ...p, ejecutivo: e.target.value }))} placeholder="Nombre del ejecutivo" data-testid="add-dest-ejecutivo" />
            </div>
            <div className="space-y-2">
              <Label>Clase de Cliente</Label>
              <Input value={addDestForm.clase_cliente} onChange={(e) => setAddDestForm((p) => ({ ...p, clase_cliente: e.target.value }))} placeholder="Ej: VIP, Corporativo, Regular" data-testid="add-dest-clase-cliente" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAddDest(false)}>Cancelar</Button>
            <Button onClick={handleAgregarDestinatario} disabled={savingAddDest} data-testid="add-dest-guardar">
              {savingAddDest ? "Guardando..." : "Agregar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={!!editingDest} onOpenChange={(open) => !open && setEditingDest(null)}>
        <DialogContent className="max-w-md" data-testid="editar-destinatario-dialog">
          <DialogHeader>
            <DialogTitle>Editar Destinatario</DialogTitle>
            <DialogDescription>{editingDest?.nombre_cliente || ""}</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Correo</Label>
              <Input
                value={editDestForm.correo}
                onChange={(e) => setEditDestForm((p) => ({ ...p, correo: e.target.value }))}
                placeholder="correo@ejemplo.com"
                data-testid="editar-dest-correo"
              />
            </div>
            <div className="space-y-2">
              <Label>Padrino</Label>
              <Input
                value={editDestForm.padrino}
                onChange={(e) => setEditDestForm((p) => ({ ...p, padrino: e.target.value }))}
                placeholder="Nombre del padrino"
                data-testid="editar-dest-padrino"
              />
            </div>
            <div className="space-y-2">
              <Label>Email Padrino</Label>
              <Input
                value={editDestForm.email_padrino}
                onChange={(e) => setEditDestForm((p) => ({ ...p, email_padrino: e.target.value }))}
                placeholder="padrino@ejemplo.com"
                data-testid="editar-dest-email-padrino"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditingDest(null)}>Cancelar</Button>
            <Button onClick={handleGuardarDestinatario} disabled={savingDest} data-testid="editar-dest-guardar">
              {savingDest ? "Guardando..." : "Guardar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Mapeo de Columnas para Importar Excel desde Destinatarios */}
      <Dialog open={destImportStep >= 2} onOpenChange={(v) => { if (!v && !destImporting) setDestImportStep(0); }}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="dest-mapeo-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Settings className="w-5 h-5" />
              {destImportStep === 2 ? "Mapeo de Columnas" : "Vista Previa de Datos Mapeados"}
            </DialogTitle>
            <DialogDescription>
              {destImportStep === 2
                ? `Revise y ajuste el mapeo sugerido. ${destMapeoData?.total_filas || 0} registros encontrados.`
                : "Revise cómo quedarán los datos antes de importarlos a la campaña"}
            </DialogDescription>
          </DialogHeader>

          {destImportStep === 2 && destMapeoData && (
            <div className="space-y-4">
              <div className="border rounded-lg overflow-hidden">
                <div className="bg-muted px-3 py-2 text-sm font-medium grid grid-cols-2 gap-4">
                  <span>Columna del Excel</span>
                  <span>Campo del Sistema</span>
                </div>
                <div className="divide-y max-h-[300px] overflow-y-auto">
                  {destMapeoData.columnas_excel?.map((col) => (
                    <div key={col} className="px-3 py-2 grid grid-cols-2 gap-4 items-center hover:bg-muted/50">
                      <div>
                        <span className="font-medium">{col}</span>
                        {destMapeoData.sample_data?.[0]?.[col] && (
                          <span className="block text-xs text-muted-foreground truncate">
                            Ej: {String(destMapeoData.sample_data[0][col]).substring(0, 30)}
                          </span>
                        )}
                      </div>
                      <Select
                        value={destMapeoActual[col] || "none"}
                        onValueChange={(v) => setDestMapeoActual({ ...destMapeoActual, [col]: v === "none" ? null : v })}
                      >
                        <SelectTrigger className="w-full" data-testid={`dest-mapeo-select-${col}`}>
                          <SelectValue placeholder="No mapear" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="none">-- No mapear --</SelectItem>
                          {destMapeoData.campos_sistema?.map((campo) => (
                            <SelectItem key={campo.id} value={campo.id}>{campo.nombre}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setDestImportStep(0)} disabled={destImporting}>Cancelar</Button>
                <Button onClick={handleDestAplicarMapeo} disabled={destImporting} data-testid="dest-mapeo-continuar-btn">
                  {destImporting ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : null}
                  Ver Vista Previa
                </Button>
              </div>
            </div>
          )}

          {destImportStep === 3 && destMappedPreview && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-3 text-center">
                <div className="p-3 rounded-lg bg-green-50 border border-green-200">
                  <div className="text-2xl font-bold text-green-700" data-testid="dest-preview-validos">{destMappedPreview.total_validos}</div>
                  <div className="text-xs text-muted-foreground">Registros válidos</div>
                </div>
                <div className="p-3 rounded-lg bg-amber-50 border border-amber-200">
                  <div className="text-2xl font-bold text-amber-700">{destMappedPreview.total_errores}</div>
                  <div className="text-xs text-muted-foreground">Con errores</div>
                </div>
              </div>
              {destMappedPreview.errores?.length > 0 && (
                <div className="p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-800 max-h-24 overflow-y-auto">
                  {destMappedPreview.errores.map((err, idx) => (<div key={idx}>{err}</div>))}
                </div>
              )}
              <div className="border rounded-lg overflow-x-auto max-h-[280px] overflow-y-auto">
                <table className="w-full text-xs">
                  <thead className="bg-muted sticky top-0">
                    <tr>
                      <th className="p-2 text-left">Correo</th>
                      <th className="p-2 text-left">Cliente</th>
                      <th className="p-2 text-left">Contacto</th>
                      <th className="p-2 text-left">Padrino</th>
                      <th className="p-2 text-left">Email Padrino</th>
                      <th className="p-2 text-left">Póliza</th>
                      <th className="p-2 text-left">Aseguradora</th>
                      <th className="p-2 text-left">No. Reclamo</th>
                      <th className="p-2 text-left">Ejecutivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {destMappedPreview.destinatarios?.map((d, idx) => (
                      <tr key={idx} className="border-t">
                        <td className="p-2">{d.correo || "-"}</td>
                        <td className="p-2">{d.nombre_cliente || "-"}</td>
                        <td className="p-2">{d.contacto || "-"}</td>
                        <td className="p-2">{d.padrino || "-"}</td>
                        <td className="p-2">{d.email_padrino || "-"}</td>
                        <td className="p-2">{d.poliza || "-"}</td>
                        <td className="p-2">{d.aseguradora || "-"}</td>
                        <td className="p-2">{d.numero_reclamo || "-"}</td>
                        <td className="p-2">{d.ejecutivo || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setDestImportStep(2)} disabled={destImporting}>Volver al Mapeo</Button>
                <Button onClick={handleDestConfirmarImport} disabled={destImporting || !destMappedPreview.total_validos} data-testid="dest-confirmar-import-btn">
                  {destImporting ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : null}
                  Importar {destMappedPreview.total_validos} Destinatarios
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog de Ver Campaña con Destinatarios y Respuestas */}
      <Dialog open={showViewDialog} onOpenChange={setShowViewDialog}>
        <DialogContent className="max-w-[95vw] max-h-[90vh] flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Eye className="w-5 h-5" />
              {viewingCampana?.nombre}
            </DialogTitle>
            <DialogDescription>
              Vista detallada de la campaña con destinatarios y respuestas
            </DialogDescription>
          </DialogHeader>

          {viewingCampana && (
            <div className="flex-1 overflow-hidden">
              {/* Resumen */}
              <div className="grid grid-cols-5 gap-4 mb-4">
                <div className="text-center p-3 bg-muted rounded-lg">
                  <div className="text-2xl font-bold">{viewingCampana.total_destinatarios || 0}</div>
                  <div className="text-xs text-muted-foreground">Destinatarios</div>
                </div>
                <div className="text-center p-3 bg-blue-50 dark:bg-blue-950 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600">{viewingCampana.total_respondidos || 0}</div>
                  <div className="text-xs text-muted-foreground">Respondidos</div>
                </div>
                <div className="text-center p-3 bg-green-50 dark:bg-green-950 rounded-lg">
                  <div className="text-2xl font-bold text-green-600">{viewingCampana.tasa_respuesta || 0}%</div>
                  <div className="text-xs text-muted-foreground">Tasa Respuesta</div>
                </div>
                <div className={`text-center p-3 rounded-lg ${viewingCampana.nps === null || viewingCampana.nps === undefined ? "bg-muted" : viewingCampana.nps >= (viewingCampana.meta_nps ?? 60) ? "bg-green-50 dark:bg-green-950" : "bg-red-50 dark:bg-red-950"}`}>
                  <div className={`text-2xl font-bold ${npsClase(viewingCampana)}`} data-testid="detalles-nps">
                    {npsCampana(viewingCampana)}
                  </div>
                  <div className="text-xs text-muted-foreground">NPS</div>
                </div>
                <div className="text-center p-3 bg-muted rounded-lg">
                  <Badge variant={viewingCampana.estado === "cerrada" ? "secondary" : "default"}>
                    {viewingCampana.estado || "borrador"}
                  </Badge>
                  <div className="text-xs text-muted-foreground mt-1">Estado</div>
                </div>
              </div>

              <Tabs value={dialogTab} onValueChange={setDialogTab} className="flex-1">
                <TabsList>
                  <TabsTrigger value="destinatarios" className="gap-2">
                    <Users className="w-4 h-4" />
                    Destinatarios ({destinatarioTotal})
                  </TabsTrigger>
                  <TabsTrigger value="respuestas" className="gap-2">
                    <MessageSquare className="w-4 h-4" />
                    Respuestas ({respuestas.length})
                  </TabsTrigger>
                </TabsList>

                <TabsContent value="destinatarios" className="mt-4 overflow-hidden">
                  {/* Filtro de estado */}
                  <div className="flex items-center gap-2 mb-4">
                    <Label>Filtrar:</Label>
                    <Select value={filterEstado} onValueChange={(v) => { setFilterEstado(v); fetchDestinatarios(viewingCampana.id, v); }}>
                      <SelectTrigger className="w-[180px]">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="todos">Todos</SelectItem>
                        <SelectItem value="pendiente">Pendientes</SelectItem>
                        <SelectItem value="enviado">Enviados</SelectItem>
                        <SelectItem value="respondido">Respondidos</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  {destinatariosLoading ? (
                    <div className="flex justify-center py-8">
                      <RefreshCw className="w-6 h-6 animate-spin" />
                    </div>
                  ) : (
                    <div className="border rounded-lg overflow-hidden max-h-[400px]">
                      <ScrollArea className="w-full h-[400px]">
                        <div className="w-full overflow-x-auto">
                          <Table>
                            <TableHeader>
                              <TableRow>
                                <TableHead className="sticky left-0 bg-background z-10 whitespace-nowrap">Cliente</TableHead>
                                <TableHead className="whitespace-nowrap">Correo</TableHead>
                                <TableHead className="whitespace-nowrap">Teléfono</TableHead>
                                <TableHead className="whitespace-nowrap">Contacto</TableHead>
                                <TableHead className="whitespace-nowrap">Póliza</TableHead>
                                <TableHead className="whitespace-nowrap">Aseguradora</TableHead>
                                <TableHead className="whitespace-nowrap">Padrino</TableHead>
                                <TableHead className="whitespace-nowrap">Email Padrino</TableHead>
                                <TableHead className="whitespace-nowrap">No. Reclamo</TableHead>
                                <TableHead className="whitespace-nowrap">Ejecutivo</TableHead>
                                <TableHead className="whitespace-nowrap">Clase de Cliente</TableHead>
                                <TableHead className="whitespace-nowrap">Estado</TableHead>
                                <TableHead className="whitespace-nowrap text-center">Link</TableHead>
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {destinatarios.map((dest) => (
                                <TableRow key={dest.id}>
                                  <TableCell className="font-medium sticky left-0 bg-background whitespace-nowrap">{dest.nombre_cliente || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.correo}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.telefono || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.contacto || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.poliza || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.aseguradora || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.padrino || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.email_padrino || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.numero_reclamo || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.ejecutivo || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">{dest.clase_cliente || "-"}</TableCell>
                                  <TableCell className="whitespace-nowrap">
                                    {dest.respondido ? (
                                      <Badge variant="success" className="gap-1">
                                        <CheckCircle className="w-3 h-3" />
                                        Respondido
                                      </Badge>
                                    ) : dest.enviado ? (
                                      <Badge variant="secondary" className="gap-1">
                                        <Clock className="w-3 h-3" />
                                        Enviado
                                      </Badge>
                                    ) : (
                                      <Badge variant="outline" className="gap-1">
                                        <AlertCircle className="w-3 h-3" />
                                        Pendiente
                                      </Badge>
                                    )}
                                  </TableCell>
                                  <TableCell className="text-center">
                                    <Button
                                      variant="ghost"
                                      size="icon"
                                      onClick={() => {
                                        const baseUrl = window.location.origin;
                                        const link = `${baseUrl}/encuesta/${dest.token}`;
                                        navigator.clipboard.writeText(link);
                                        toast.success("Link copiado al portapapeles");
                                      }}
                                      title="Copiar link de encuesta"
                                    >
                                      <Copy className="w-4 h-4" />
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                        <ScrollBar orientation="horizontal" />
                      </ScrollArea>
                    </div>
                  )}

                  {/* Paginación */}
                  {destinatarioTotal > 50 && (
                    <div className="flex items-center justify-between mt-4">
                      <span className="text-sm text-muted-foreground">
                        Página {destinatarioPage} de {Math.ceil(destinatarioTotal / 50)}
                      </span>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => fetchDestinatarios(viewingCampana.id, filterEstado, destinatarioPage - 1)}
                          disabled={destinatarioPage <= 1}
                        >
                          <ChevronLeft className="w-4 h-4" />
                          Anterior
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => fetchDestinatarios(viewingCampana.id, filterEstado, destinatarioPage + 1)}
                          disabled={destinatarioPage >= Math.ceil(destinatarioTotal / 50)}
                        >
                          Siguiente
                          <ChevronRight className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  )}
                </TabsContent>

                <TabsContent value="respuestas" className="mt-4 overflow-hidden">
                  {respuestasLoading ? (
                    <div className="flex justify-center py-8">
                      <RefreshCw className="w-6 h-6 animate-spin" />
                    </div>
                  ) : respuestas.length === 0 ? (
                    <div className="text-center py-8 text-muted-foreground">
                      <MessageSquare className="w-12 h-12 mx-auto mb-4 opacity-50" />
                      <p>No hay respuestas registradas aún</p>
                    </div>
                  ) : (
                    <div className="space-y-4 max-h-[400px] overflow-y-auto">
                      {respuestas.map((resp, idx) => (
                        <Card key={resp.id || idx}>
                          <CardHeader className="pb-2">
                            <div className="flex items-center justify-between">
                              <div>
                                <CardTitle className="text-base">
                                  {resp.destinatario?.nombre_cliente || resp.destinatario?.correo || "Anónimo"}
                                </CardTitle>
                                <CardDescription>
                                  {resp.destinatario?.correo} • {resp.destinatario?.poliza ? `Póliza: ${resp.destinatario.poliza}` : ""} • {resp.destinatario?.aseguradora || ""}
                                </CardDescription>
                              </div>
                              <div className="text-right">
                                <p className="text-sm text-muted-foreground">
                                  {resp.fecha_respuesta ? new Date(resp.fecha_respuesta).toLocaleString() : ""}
                                </p>
                                {resp.nps_score !== undefined && (
                                  <Badge variant={resp.nps_score >= 9 ? "success" : resp.nps_score >= 7 ? "warning" : "destructive"}>
                                    NPS: {resp.nps_score}
                                  </Badge>
                                )}
                              </div>
                            </div>
                          </CardHeader>
                          <CardContent>
                            <div className="space-y-2">
                              {Array.isArray(resp.respuestas) && resp.respuestas.map((r, rIdx) => (
                                <div key={rIdx} className="p-2 bg-muted rounded">
                                  <p className="text-sm font-medium">{typeof r === 'object' ? r.pregunta : 'Respuesta'}</p>
                                  <p className="text-sm text-muted-foreground">{typeof r === 'object' ? r.respuesta : r}</p>
                                </div>
                              ))}
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                    </div>
                  )}
                </TabsContent>
              </Tabs>
            </div>
          )}

          <DialogFooter className="mt-4">
            <Button 
              variant="outline" 
              onClick={() => handleExportExcel(viewingCampana?.id)}
              disabled={!viewingCampana || exportingExcel}
            >
              {exportingExcel ? (
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Download className="w-4 h-4 mr-2" />
              )}
              {exportingExcel ? "Exportando..." : "Exportar Excel"}
            </Button>
            <Button variant="outline" onClick={() => setShowViewDialog(false)}>
              Cerrar
            </Button>
            <Button onClick={() => { setShowViewDialog(false); openEdit(viewingCampana); }}>
              <Pencil className="w-4 h-4 mr-2" />
              Editar Campaña
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Análisis de Encuesta */}
      <Dialog open={showAnalisisDialog} onOpenChange={setShowAnalisisDialog}>
        <DialogContent className="max-w-5xl max-h-[95vh] flex flex-col p-0 overflow-hidden">
          <DialogHeader className="flex-shrink-0 p-6 pb-4 border-b">
            <DialogTitle className="flex items-center gap-2">
              <BarChart3 className="w-5 h-5 text-blue-600" />
              Análisis de Encuesta: {selectedCampana?.nombre}
            </DialogTitle>
            <DialogDescription>
              Informe detallado de resultados y estadísticas
            </DialogDescription>
          </DialogHeader>
          
          {analisisLoading ? (
            <div className="flex items-center justify-center py-12 flex-1">
              <Loader2 className="w-8 h-8 animate-spin text-primary" />
              <span className="ml-2">Cargando análisis...</span>
            </div>
          ) : analisisData ? (
            <div className="flex-1 min-h-0 overflow-y-auto px-6 py-4" style={{ maxHeight: 'calc(95vh - 180px)' }}>
              <div className="space-y-6 pb-4">
                {/* Respuestas individuales de los clientes */}
                <Card data-testid="respuestas-individuales-card" className="border-blue-300 bg-blue-50 dark:border-blue-800 dark:bg-blue-950/30">
                  <CardHeader className="pb-2">
                    <div className="flex items-center justify-between flex-wrap gap-2">
                      <div>
                        <CardTitle className="text-base flex items-center gap-2 text-blue-800 dark:text-blue-200">
                          <Users className="w-4 h-4 text-blue-600" />
                          Respuestas Individuales
                        </CardTitle>
                        <CardDescription className="text-xs">
                          Vea quién respondió la encuesta y sus respuestas, sin descargar el Excel
                        </CardDescription>
                      </div>
                      <Button
                        size="sm"
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        onClick={handleVerRespuestasInd}
                        disabled={respuestasIndLoading}
                        data-testid="ver-respuestas-individuales-btn"
                      >
                        {respuestasIndLoading ? (
                          <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                        ) : (
                          <Eye className="w-4 h-4 mr-1" />
                        )}
                        {showRespuestasInd ? "Ocultar respuestas" : "Ver respuestas"}
                      </Button>
                    </div>
                  </CardHeader>
                  {showRespuestasInd && respuestasInd && (
                    <CardContent className="space-y-3">
                      {respuestasInd.respuestas.length === 0 ? (
                        <p className="text-sm text-gray-400 italic">Aún no hay respuestas para esta campaña</p>
                      ) : (
                        respuestasInd.respuestas.map((r, i) => (
                          <div key={i} className="border rounded-lg overflow-hidden bg-white dark:bg-slate-900" data-testid={`respuesta-individual-${i}`}>
                            <div className="bg-slate-50 dark:bg-slate-800 px-3 py-2 flex items-center justify-between flex-wrap gap-2">
                              <div className="min-w-0">
                                <p className="font-semibold text-sm truncate">{r.nombre}</p>
                                <p className="text-xs text-gray-500 truncate">
                                  {[r.correo, r.ejecutivo ? `Ejecutivo: ${r.ejecutivo}` : "", r.fecha].filter(Boolean).join(" · ")}
                                </p>
                              </div>
                              {r.nps_score !== null && r.nps_score !== undefined && r.nps_score !== "" && (
                                <Badge className={Number(r.nps_score) >= 9 ? "bg-green-100 text-green-800" : Number(r.nps_score) >= 7 ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800"}>
                                  NPS {r.nps_score}
                                </Badge>
                              )}
                            </div>
                            <div className="px-3 py-2 space-y-2">
                              {respuestasInd.preguntas.map((p, idx) => (
                                <div key={p.id} className="text-sm">
                                  <p className="text-xs text-gray-500">P{idx + 1}. {p.pregunta}</p>
                                  <p className={r.respuestas[p.id] ? "font-medium" : "text-gray-400 italic"}>
                                    {r.respuestas[p.id] || "Sin respuesta"}
                                  </p>
                                </div>
                              ))}
                              {r.comentario_general && (
                                <div className="text-sm">
                                  <p className="text-xs text-gray-500">Comentario general</p>
                                  <p className="font-medium">"{r.comentario_general}"</p>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </CardContent>
                  )}
                </Card>

                {/* Métricas Generales */}
                <Card>
                  <CardHeader className="pb-2">
                    <CardTitle className="text-base">Métricas Generales</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="text-center p-3 bg-blue-50 rounded-lg">
                        <p className="text-2xl font-bold text-blue-600">{analisisData.metricas?.total_destinatarios || 0}</p>
                        <p className="text-xs text-gray-500">Total Destinatarios</p>
                      </div>
                      <div className="text-center p-3 bg-green-50 rounded-lg">
                        <p className="text-2xl font-bold text-green-600">{analisisData.metricas?.total_respuestas || 0}</p>
                        <p className="text-xs text-gray-500">Total Respuestas</p>
                      </div>
                      <div className={`text-center p-3 rounded-lg ${analisisData.metricas?.nps_general === null || analisisData.metricas?.nps_general === undefined ? 'bg-slate-50' : analisisData.metricas.nps_general >= 50 ? 'bg-green-50' : analisisData.metricas.nps_general >= 0 ? 'bg-yellow-50' : 'bg-red-50'}`}>
                        <p className={`text-2xl font-bold ${analisisData.metricas?.nps_general === null || analisisData.metricas?.nps_general === undefined ? 'text-slate-400' : analisisData.metricas.nps_general >= 50 ? 'text-green-600' : analisisData.metricas.nps_general >= 0 ? 'text-yellow-600' : 'text-red-600'}`} data-testid="analisis-nps-general">
                          {analisisData.metricas?.nps_general ?? "—"}
                        </p>
                        <p className="text-xs text-gray-500">NPS General</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* NPS por Ejecutivo */}
                {analisisData.por_ejecutivo && analisisData.por_ejecutivo.length > 0 && (
                  <Card data-testid="analisis-nps-por-ejecutivo">
                    <CardHeader className="pb-2">
                      <CardTitle className="text-base flex items-center gap-2">
                        <Award className="w-4 h-4 text-amber-500" />
                        NPS por Ejecutivo
                      </CardTitle>
                      <CardDescription className="text-xs">
                        Ordenado de menor a mayor NPS — los que requieren atención aparecen primero
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="border-b text-left text-xs text-gray-500">
                              <th className="py-2 pr-2">Ejecutivo</th>
                              <th className="py-2 px-2 text-center">NPS</th>
                              <th className="py-2 px-2 text-center">Satisf.</th>
                              <th className="py-2 px-2 text-center">Respuestas</th>
                              <th className="py-2 px-2 text-center">Prom. / Pas. / Detr.</th>
                            </tr>
                          </thead>
                          <tbody>
                            {analisisData.por_ejecutivo.map((ej) => (
                              <tr key={ej.ejecutivo} className="border-b" data-testid={`ejecutivo-row-${ej.ejecutivo}`}>
                                <td className="py-2 pr-2 font-medium">{ej.ejecutivo}</td>
                                <td className={`py-2 px-2 text-center font-bold ${ej.nps === null ? 'text-gray-400' : ej.nps >= 60 ? 'text-green-600' : 'text-red-600'}`}>
                                  {ej.nps === null ? '-' : ej.nps}
                                </td>
                                <td className="py-2 px-2 text-center">{ej.satisfaccion_promedio ?? '-'}</td>
                                <td className="py-2 px-2 text-center">{ej.total_respuestas}</td>
                                <td className="py-2 px-2">
                                  <div className="flex justify-center gap-1">
                                    <span className="px-1.5 rounded bg-green-50 text-green-700 text-xs">{ej.promotores}</span>
                                    <span className="px-1.5 rounded bg-yellow-50 text-yellow-700 text-xs">{ej.pasivos}</span>
                                    <span className="px-1.5 rounded bg-red-50 text-red-700 text-xs">{ej.detractores}</span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Análisis por Pregunta */}
                {analisisData.preguntas?.map((pregunta, idx) => (
                  <Card key={pregunta.pregunta_id}>
                    <CardHeader className="pb-2 bg-slate-50">
                      <CardTitle className="text-sm font-medium">
                        P{idx + 1}. {pregunta.pregunta}
                      </CardTitle>
                      <CardDescription className="text-xs">
                        Respondidas: {pregunta.respondidas} | Omitidas: {pregunta.omitidas}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="pt-4">
                      {/* Preguntas de escala (NPS, satisfacción, escala) */}
                      {['nps', 'satisfaccion', 'escala'].includes(pregunta.tipo) && pregunta.promedio !== null && (
                        <div className="space-y-4">
                          <div className="flex items-center gap-4">
                            <div className="text-center p-3 bg-blue-50 rounded-lg">
                              <p className="text-3xl font-bold text-blue-600">{pregunta.promedio}</p>
                              <p className="text-xs text-gray-500">Promedio</p>
                            </div>
                            
                            {pregunta.tipo === 'nps' && pregunta.nps_categorias && (
                              <div className="flex gap-2 flex-1">
                                <div className="flex-1 text-center p-2 bg-green-50 rounded">
                                  <p className="font-bold text-green-600">{pregunta.nps_categorias.promotores?.cantidad || 0}</p>
                                  <p className="text-xs">Promotores ({pregunta.nps_categorias.promotores?.porcentaje || 0}%)</p>
                                </div>
                                <div className="flex-1 text-center p-2 bg-yellow-50 rounded">
                                  <p className="font-bold text-yellow-600">{pregunta.nps_categorias.pasivos?.cantidad || 0}</p>
                                  <p className="text-xs">Pasivos ({pregunta.nps_categorias.pasivos?.porcentaje || 0}%)</p>
                                </div>
                                <div className="flex-1 text-center p-2 bg-red-50 rounded">
                                  <p className="font-bold text-red-600">{pregunta.nps_categorias.detractores?.cantidad || 0}</p>
                                  <p className="text-xs">Detractores ({pregunta.nps_categorias.detractores?.porcentaje || 0}%)</p>
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Distribución de valores */}
                          {pregunta.distribucion && Object.keys(pregunta.distribucion).length > 0 && (
                            <div className="space-y-4">
                              <p className="text-sm font-medium">Distribución de Respuestas</p>
                              
                              {/* Gráfico de barras */}
                              <div className="h-64 w-full">
                                <ResponsiveContainer width="100%" height="100%">
                                  <BarChart
                                    data={Object.entries(pregunta.distribucion)
                                      .map(([valor, data]) => ({
                                        valor: valor,
                                        cantidad: data.cantidad,
                                        porcentaje: data.porcentaje
                                      }))
                                      .sort((a, b) => parseInt(a.valor) - parseInt(b.valor))
                                    }
                                    layout="vertical"
                                    margin={{ top: 5, right: 30, left: 40, bottom: 5 }}
                                  >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis type="number" />
                                    <YAxis 
                                      dataKey="valor" 
                                      type="category" 
                                      width={40}
                                      reversed={false}
                                    />
                                    <Tooltip 
                                      formatter={(value, name) => [
                                        name === 'cantidad' ? `${value} respuestas` : `${value}%`,
                                        name === 'cantidad' ? 'Cantidad' : 'Porcentaje'
                                      ]}
                                    />
                                    <Bar dataKey="cantidad" name="Cantidad" radius={[0, 4, 4, 0]}>
                                      {Object.entries(pregunta.distribucion)
                                        .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
                                        .map(([valor, data], index) => {
                                          // Colores para NPS: rojo (0-6), amarillo (7-8), verde (9-10)
                                          let color = '#3B82F6'; // default blue
                                          const numVal = parseInt(valor);
                                          if (pregunta.tipo === 'nps') {
                                            if (numVal <= 6) color = '#EF4444'; // red
                                            else if (numVal <= 8) color = '#F59E0B'; // yellow
                                            else color = '#22C55E'; // green
                                          }
                                          return <Cell key={`cell-${index}`} fill={color} />;
                                        })}
                                    </Bar>
                                  </BarChart>
                                </ResponsiveContainer>
                              </div>

                              {/* Tabla de distribución */}
                              <div className="border rounded-lg overflow-hidden">
                                <Table>
                                  <TableHeader>
                                    <TableRow>
                                      <TableHead className="w-20 bg-slate-50">Valor</TableHead>
                                      <TableHead className="bg-slate-50">Barra</TableHead>
                                      <TableHead className="text-right w-24 bg-slate-50">Cantidad</TableHead>
                                      <TableHead className="text-right w-24 bg-slate-50">Porcentaje</TableHead>
                                    </TableRow>
                                  </TableHeader>
                                  <TableBody>
                                    {Object.entries(pregunta.distribucion).map(([valor, data]) => (
                                      <TableRow key={valor}>
                                        <TableCell className="font-medium">{valor}</TableCell>
                                        <TableCell>
                                          <div className="w-full min-w-[100px] h-4 rounded-full overflow-hidden" 
                                               style={{ backgroundColor: data.cantidad > 0 ? '#E5E7EB' : 'transparent' }}>
                                            {data.cantidad > 0 && (
                                              <div 
                                                className="h-4 rounded-full transition-all" 
                                                style={{ 
                                                  width: `${data.porcentaje}%`,
                                                  backgroundColor: pregunta.tipo === 'nps' 
                                                    ? (parseInt(valor) <= 6 ? '#EF4444' : parseInt(valor) <= 8 ? '#F59E0B' : '#22C55E')
                                                    : '#3B82F6'
                                                }}
                                              />
                                            )}
                                          </div>
                                        </TableCell>
                                        <TableCell className="text-right">{data.cantidad}</TableCell>
                                        <TableCell className="text-right">{data.porcentaje}%</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Preguntas de opción múltiple o selección múltiple */}
                      {(pregunta.tipo === 'opcion_multiple' || pregunta.tipo === 'seleccion_multiple') && pregunta.distribucion && Object.keys(pregunta.distribucion).length > 0 && (
                        <div className="space-y-4">
                          {/* Indicador de tipo */}
                          {pregunta.tipo === 'seleccion_multiple' && (
                            <p className="text-xs text-blue-600 font-medium">
                              ✓ Selección múltiple - los encuestados podían elegir varias opciones
                            </p>
                          )}
                          
                          {/* Gráfico de barras para opciones */}
                          <div className="h-64 w-full">
                            <ResponsiveContainer width="100%" height="100%">
                              <BarChart
                                data={Object.entries(pregunta.distribucion).map(([opcion, data]) => ({
                                  opcion: opcion.length > 25 ? opcion.substring(0, 25) + '...' : opcion,
                                  cantidad: data.cantidad,
                                  porcentaje: data.porcentaje
                                }))}
                                layout="vertical"
                                margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" />
                                <YAxis dataKey="opcion" type="category" width={90} tick={{ fontSize: 11 }} />
                                <Tooltip 
                                  formatter={(value, name) => [
                                    name === 'cantidad' ? `${value} respuestas` : `${value}%`,
                                    name === 'cantidad' ? 'Cantidad' : 'Porcentaje'
                                  ]}
                                />
                                <Bar dataKey="cantidad" name="Cantidad" fill="#22C55E" radius={[0, 4, 4, 0]} />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>

                          {/* Tabla de opciones */}
                          <div className="border rounded-lg overflow-hidden">
                            <Table>
                              <TableHeader>
                                <TableRow>
                                  <TableHead className="bg-slate-50">Opción</TableHead>
                                  <TableHead className="bg-slate-50">Barra</TableHead>
                                  <TableHead className="text-right w-24 bg-slate-50">Cantidad</TableHead>
                                  <TableHead className="text-right w-24 bg-slate-50">Porcentaje</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {Object.entries(pregunta.distribucion).map(([opcion, data]) => (
                                  <TableRow key={opcion}>
                                    <TableCell className="font-medium">{opcion}</TableCell>
                                    <TableCell>
                                      <div className="w-full min-w-[100px] h-4 rounded-full overflow-hidden"
                                           style={{ backgroundColor: data.cantidad > 0 ? '#E5E7EB' : 'transparent' }}>
                                        {data.cantidad > 0 && (
                                          <div 
                                            className="bg-green-500 h-4 rounded-full transition-all" 
                                            style={{ width: `${Math.min(data.porcentaje, 100)}%` }}
                                          />
                                        )}
                                      </div>
                                    </TableCell>
                                    <TableCell className="text-right">{data.cantidad}</TableCell>
                                    <TableCell className="text-right">{data.porcentaje}%</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </div>
                          <p className="text-xs text-gray-500">
                            Total selecciones: {pregunta.total_selecciones || 0}
                            {pregunta.total_respondidas && ` de ${pregunta.total_respondidas} encuestados`}
                          </p>
                        </div>
                      )}
                      
                      {/* Si es selección múltiple pero no hay distribución */}
                      {(pregunta.tipo === 'opcion_multiple' || pregunta.tipo === 'seleccion_multiple') && (!pregunta.distribucion || Object.keys(pregunta.distribucion).length === 0) && (
                        <p className="text-sm text-gray-400 italic">Sin respuestas registradas para esta pregunta</p>
                      )}

                      {/* Preguntas de texto */}
                      {pregunta.tipo === 'texto' && (
                        <div>
                          <p className="text-sm text-gray-500 mb-2">Total comentarios: {pregunta.total_comentarios}</p>
                          {pregunta.respuestas_texto?.length > 0 ? (
                            <div className="space-y-2 max-h-48 overflow-y-auto">
                              {pregunta.respuestas_texto.slice(0, 10).map((texto, i) => (
                                <div key={i} className="p-2 bg-gray-50 rounded text-sm">
                                  "{texto}"
                                </div>
                              ))}
                              {pregunta.respuestas_texto.length > 10 && (
                                <p className="text-xs text-gray-500">
                                  ...y {pregunta.respuestas_texto.length - 10} comentarios más
                                </p>
                              )}
                            </div>
                          ) : (
                            <p className="text-sm text-gray-400 italic">Sin comentarios</p>
                          )}
                        </div>
                      )}
                    </CardContent>
                  </Card>
                ))}

                {/* Información de generación */}
                <p className="text-xs text-gray-400 text-center">
                  Informe generado: {new Date(analisisData.fecha_generacion).toLocaleString()}
                </p>
              </div>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500 flex-1">
              No hay datos de análisis disponibles
            </div>
          )}

          <DialogFooter className="flex-shrink-0 border-t p-6 pt-4">
            <div className="flex gap-2 w-full justify-between">
              <div className="flex gap-2 flex-wrap">
                <Button
                  variant="outline"
                  onClick={handleExportarRespuestasExcel}
                  disabled={exportingAnalisis || !analisisData}
                  title="Descarga todas las respuestas con datos de contacto"
                >
                  {exportingAnalisis ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Download className="w-4 h-4 mr-2" />
                  )}
                  Descargar Respuestas
                </Button>
                <Button
                  variant="outline"
                  onClick={handleExportarAnalisisExcel}
                  disabled={exportingAnalisis || !analisisData}
                >
                  {exportingAnalisis ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <FileSpreadsheet className="w-4 h-4 mr-2" />
                  )}
                  Exportar Análisis
                </Button>
                <Button
                  variant="outline"
                  onClick={handleExportarAnalisisPDF}
                  disabled={exportingAnalisis || !analisisData}
                >
                  {exportingAnalisis ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <FileText className="w-4 h-4 mr-2" />
                  )}
                  Exportar PDF
                </Button>
              </div>
              <Button variant="outline" onClick={() => setShowAnalisisDialog(false)}>
                Cerrar
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      </main>
    </div>
  );
}

